import React from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getTranslate } from "react-localize-redux";
import moment from "moment";
import ContentEditable from "react-contenteditable";
import { Form, Button, Container, Row, Col } from "reactstrap";
import { isMobile } from "react-device-detect";
import { actions } from "react-redux-form";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import { StickyContainer, Sticky } from "react-sticky";
import {
  configActions,
  fileActions,
  documentActions,
  dashboardActions,
  smartSearchActions,
  userActions,
} from "../../../redux/actions";
import {
  getDocumentsWithoutPlatformSpecificParams,
  getFilesParams,
  random,
} from "../../../utils";
import {
  initConfigReportsSearchFormState,
  initDashboardSearchFormState,
  initDocsSearchFormState,
  initExecReportsSearchFormState,
  initFilesSearchFormState,
  initHomeSearchFormState,
} from "../../../utils/constants";

import "./SmartSearch.css";

const delaysErrorStatus = ["VeryLow", "Low", "Medium", "High", "VeryHigh"];

class SmartSearch extends React.Component {
  constructor(props) {
    super(props);
    this.contentEditable = React.createRef();
    this.state = {
      showSearchWarning: false,
      showSearchWarning2: false,
    };
  }
  onSearchTextFieldChange = (event) => {
    const { smartSearchParams } = this.props;
    //event.target.value
    this.props.dispatch(
      actions.change(`smartSearchParams`, {
        ...smartSearchParams,
        SearchText: event.currentTarget.innerText,
      })
    );
  };

  onSearchWarningDismiss = () => {
    this.setState({
      showSearchWarning: false,
    });
  };

  onSearchWarning2Dismiss = () => {
    this.setState({
      showSearchWarning2: false,
    });
  };

  onSearchClick = (event) => {
    event.preventDefault();
    const {
      allCustomers,
      allChannels,
      availableUsers,
      smartSearchParams,
      dispatch,
    } = this.props;

    if (
      smartSearchParams.SearchText &&
      smartSearchParams.SearchText.toString().trim().length > 1
    ) {
      this.setState({
        showSearchWarning: false,
      });
      let _searchText = smartSearchParams.SearchText.toString().trim();
      const ebidRegex = new RegExp(/^BEL[a-zA-Z0-9]{32}$/, "i");
      let ebidSearch = false;
      let _docIds = _searchText.split(",");
      if (_docIds.length > 20) {
        this.setState({
          showSearchWarning2: true,
        });
        return;
      } else {
        this.setState({
          showSearchWarning2: false,
        });
      }

      for (let i = 0; i < _docIds.length; i++) {
        const element = _docIds[i];
        if (element && element.trim().match(ebidRegex)) {
          ebidSearch = true; // at least one item is ebid
          break;
        }
      }

      var _params = {
        PageNumber: 1,
        Size: _docIds.length > 1 ? 50 : 5,
        DocId: _searchText,
      };
      dispatch(
        smartSearchActions.getFilteredDocsbyEBID(
          getDocumentsWithoutPlatformSpecificParams({
            ..._params,
          }),
          ebidSearch,
          _searchText
        )
      );

      dispatch(
        actions.change("smartSearchParams", {
          ...smartSearchParams,
          SearchText: _searchText,
        })
      );
      if (!ebidSearch) {
        if (_docIds.length === 1) {
          const regex = new RegExp(_searchText, "i");
          let customersFilteredByName = [];
          let customersFilteredByUserName = (availableUsers || []).filter(
            (user) => user.UserId && user.UserId.match(regex)
          );
          let customersFilteredByProjectName = [];
          let customersFilteredBySender = [];
          (allCustomers || []).forEach(function (obj) {
            if (obj.name.match(regex)) {
              customersFilteredByName.push(Object.assign({}, obj));
            }
            //let foundLegacyIdUserName = null;
            let foundProjectName = null;
            let foundProjectId = null;
            let foundSenderId = null;
            let foundSenderName = null;
            var i = 0;
            if (obj.projects && obj.projects.length) {
              for (i = 0; i < obj.projects.length; i++) {
                if (obj.projects[i].name.match(regex)) {
                  foundProjectName = obj.projects[i].name;
                  foundProjectId = obj.projects[i].projectId;
                  break;
                }
              }
            }
            if (obj.senders && obj.senders.length) {
              for (i = 0; i < obj.senders.length; i++) {
                if (obj.senders[i].senderCompanyName.match(regex)) {
                  foundSenderId = obj.senders[i].senderId;
                  foundSenderName = obj.senders[i].senderCompanyName;
                  break;
                }
              }
            }
            if (foundProjectName && foundProjectId) {
              customersFilteredByProjectName.push(
                Object.assign({}, obj, {
                  foundProjectName: foundProjectName,
                  foundProjectId,
                })
              );
            }
            if (foundSenderName && foundSenderId) {
              customersFilteredBySender.push(
                Object.assign({}, obj, {
                  foundSenderId: foundSenderId,
                  foundSenderName,
                })
              );
            }

            if (obj.childList && obj.childList.length) {
              obj.childList.forEach(function (subObj) {
                if (subObj.name.match(regex)) {
                  customersFilteredByName.push(Object.assign({}, subObj));
                }
                //let foundLegacyIdUserName = null;
                let foundProjectName = null;
                let foundProjectId = null;
                let foundSenderId = null;
                let foundSenderName = null;
                var i = 0;
                if (subObj.projects && subObj.projects.length) {
                  for (i = 0; i < subObj.projects.length; i++) {
                    if (subObj.projects[i].name.match(regex)) {
                      foundProjectName = subObj.projects[i].name;
                      foundProjectId = subObj.projects[i].projectId;
                      break;
                    }
                  }
                }
                if (subObj.senders && subObj.senders.length) {
                  for (i = 0; i < subObj.senders.length; i++) {
                    if (subObj.senders[i].senderCompanyName.match(regex)) {
                      foundSenderId = subObj.senders[i].senderId;
                      foundSenderName = subObj.senders[i].senderCompanyName;
                      break;
                    }
                  }
                }
                if (foundProjectName && foundProjectId) {
                  customersFilteredByProjectName.push(
                    Object.assign({}, subObj, {
                      foundProjectName: foundProjectName,
                      foundProjectId,
                    })
                  );
                }
                if (foundSenderName && foundSenderId) {
                  customersFilteredBySender.push(
                    Object.assign({}, subObj, {
                      foundSenderId: foundSenderId,
                      foundSenderName,
                    })
                  );
                }
              });
            }
          });
          dispatch(
            smartSearchActions.setCustomersFilteredByName(
              customersFilteredByName
            )
          );
          dispatch(
            smartSearchActions.setCustomersFilteredByUserName(
              customersFilteredByUserName
            )
          );
          let filteredChannels = (allChannels || []).filter(
            (ch) => ch && ch.match(regex)
          );
          dispatch(smartSearchActions.setFilteredChannels(filteredChannels));
          dispatch(
            smartSearchActions.setCustomersFilteredByProjectName(
              customersFilteredByProjectName
            )
          );
          dispatch(
            smartSearchActions.setCustomersFilteredBySender(
              customersFilteredBySender
            )
          );
        }
        _params = {
          PageNumber: 1,
          Size: _docIds.length > 1 ? 50 : 5,
        };
        _params["DocumentNumbers"] = _searchText;
        _params["IsPlatformSpecific"] = false;
        dispatch(
          smartSearchActions.getFilteredDocs(
            getDocumentsWithoutPlatformSpecificParams({
              ..._params,
            })
          )
        );
        if (_docIds.length === 1) {
          _params = {
            PageNumber: 1,
            Size: 5,
          };
          _params["Sender"] = _searchText;
          _params["IsPlatformSpecific"] = false;
          dispatch(smartSearchActions.getFilteredDocsSender(_params));

          _params = {
            PageNumber: 1,
            Size: 5,
          };
          _params["SenderName"] = _searchText;
          _params["IsPlatformSpecific"] = false;
          dispatch(smartSearchActions.getFilteredDocsSenderName(_params));
          _params = {
            PageNumber: 1,
            Size: 5,
          };
          _params["Receiver"] = _searchText;
          _params["IsPlatformSpecific"] = false;
          dispatch(smartSearchActions.getFilteredDocsReceiver(_params));
          _params = {
            PageNumber: 1,
            Size: 5,
          };
          _params["ReceiverName"] = _searchText;
          _params["IsPlatformSpecific"] = false;
          dispatch(smartSearchActions.getFilteredDocsReceiverName(_params));
          _params = {
            PageNumber: 1,
            Size: 5,
          };
          _params["FileNames"] = _searchText;
          _params["IsPlatformSpecific"] = false;
          dispatch(smartSearchActions.getFilteredFiles(_params));

          _params = {
            PageNumber: 1,
            Size: 5,
          };

          _params["CustomerId"] = _searchText;
          _params["IsPlatformSpecific"] = true;
          dispatch(smartSearchActions.getFilteredFilesByCustomerId(_params));

          _params = {
            PageNumber: 1,
            Size: 5,
          };
          _params["BatchId"] = _searchText;
          //_params["Start"] = "2017-09-01T09:59:32.000";
          _params["IsPlatformSpecific"] = true;
          dispatch(smartSearchActions.getFilteredBatches(_params));
        }
      }
    } else {
      // show fading tooltip warn
      this.setState({
        showSearchWarning: true,
        showSearchWarning2: false,
      });
    }
  };

  showMoreFiles = (event) => {
    event.preventDefault();
    const { dispatch, history, pageItemCount, smartSearchText, translate } =
      this.props;
    dispatch(
      actions.change("fileSearch", {
        ...initFilesSearchFormState,
        FileNames: smartSearchText && smartSearchText.trim(),
        Size: pageItemCount,
      })
    );
    dispatch(
      fileActions.getAll(
        getFilesParams(
          {
            ...initFilesSearchFormState,
            FileNames: smartSearchText && smartSearchText.trim(),
            Size: pageItemCount,
          },
          false,
          "",
          {}
        ),
        `${translate("LoadingFiles")}...`
      )
    );
    history.push("/files");
  };

  showMoreFilesByCustomerId = (event) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount, smartSearchText } =
      this.props;
    dispatch(
      actions.change("fileSearch", {
        ...initFilesSearchFormState,
        CustomerLegacyId: smartSearchText && smartSearchText.trim(),
        Size: pageItemCount,
        moreArrowIcon: "fa-chevron-up",
        toggleBtnTitle: "Hide advanced search options",
        showMoreHeight: "auto",
      })
    );
    dispatch(
      fileActions.getAll(
        getFilesParams(
          {
            ...initFilesSearchFormState,
            CustomerLegacyId: smartSearchText && smartSearchText.trim(),
            Size: pageItemCount,
          },
          false,
          "",
          {}
        ),
        `${translate("LoadingFiles")}...`
      )
    );
    history.push("/files");
  };

  showMoreDocs = (event) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount, smartSearchText } =
      this.props;
    dispatch(documentActions.clearDocuments());
    dispatch(
      actions.change("docSearch", {
        ...initDocsSearchFormState,
        DocumentNumbers: smartSearchText && smartSearchText.trim(),
        Size: pageItemCount,
      })
    );
    dispatch(
      documentActions.getAll(
        getDocumentsWithoutPlatformSpecificParams({
          ...initDocsSearchFormState,
          DocumentNumbers: smartSearchText && smartSearchText.trim(),
          Size: pageItemCount,
        }),
        `${translate("LoadingDocuments")}...`
      )
    );
    history.push("/documents");
  };

  showMoreDocsSender = (event) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount, smartSearchText } =
      this.props;
    dispatch(documentActions.clearDocuments());
    dispatch(
      actions.change("docSearch", {
        ...initDocsSearchFormState,
        BySenderId: false,
        Sender: smartSearchText && smartSearchText.trim(),
        Size: pageItemCount,
        moreArrowIcon: "fa-chevron-up",
        toggleBtnTitle: "Hide advanced search options",
        showMoreHeight: "auto",
      })
    );
    dispatch(
      documentActions.getAll(
        getDocumentsWithoutPlatformSpecificParams({
          ...initDocsSearchFormState,
          Sender: smartSearchText && smartSearchText.trim(),
          Size: pageItemCount,
        }),
        `${translate("LoadingDocuments")}...`
      )
    );
    history.push("/documents");
  };

  showMoreDocsSenderName = (event) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount, smartSearchText } =
      this.props;
    dispatch(documentActions.clearDocuments());
    dispatch(
      actions.change("docSearch", {
        ...initDocsSearchFormState,
        BySenderId: true,
        Sender: smartSearchText && smartSearchText.trim(),
        Size: pageItemCount,
        moreArrowIcon: "fa-chevron-up",
        toggleBtnTitle: "Hide advanced search options",
        showMoreHeight: "auto",
      })
    );
    dispatch(
      documentActions.getAll(
        getDocumentsWithoutPlatformSpecificParams({
          ...initDocsSearchFormState,
          SenderName: smartSearchText && smartSearchText.trim(),
          Size: pageItemCount,
        }),
        `${translate("LoadingDocuments")}...`
      )
    );
    history.push("/documents");
  };

  showMoreDocsReceiver = (event) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount, smartSearchText } =
      this.props;
    dispatch(documentActions.clearDocuments());
    dispatch(
      actions.change("docSearch", {
        ...initDocsSearchFormState,
        ByReceiverId: false,
        Receiver: smartSearchText && smartSearchText.trim(),
        Size: pageItemCount,
        moreArrowIcon: "fa-chevron-up",
        toggleBtnTitle: "Hide advanced search options",
        showMoreHeight: "auto",
      })
    );
    dispatch(
      documentActions.getAll(
        getDocumentsWithoutPlatformSpecificParams({
          ...initDocsSearchFormState,
          Receiver: smartSearchText && smartSearchText.trim(),
          Size: pageItemCount,
        }),
        `${translate("LoadingDocuments")}...`
      )
    );
    history.push("/documents");
  };

  showMoreDocsReceiverName = (event) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount, smartSearchText } =
      this.props;
    dispatch(documentActions.clearDocuments());
    dispatch(
      actions.change("docSearch", {
        ...initDocsSearchFormState,
        ByReceiverId: true,
        Receiver: smartSearchText && smartSearchText.trim(),
        Size: pageItemCount,
        moreArrowIcon: "fa-chevron-up",
        toggleBtnTitle: "Hide advanced search options",
        showMoreHeight: "auto",
      })
    );
    dispatch(
      documentActions.getAll(
        getDocumentsWithoutPlatformSpecificParams({
          ...initDocsSearchFormState,
          ReceiverName: smartSearchText && smartSearchText.trim(),
          Size: pageItemCount,
        }),
        `${translate("LoadingDocuments")}...`
      )
    );
    history.push("/documents?");
  };

  viewFilesByCustomer = (event, item) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount } = this.props;
    dispatch(
      actions.change("fileSearch", {
        ...initFilesSearchFormState,
        CustomerId: item.globalId,
        Size: pageItemCount,
      })
    );
    dispatch(
      configActions.filterProjectByCustomerId(item.globalId, "filesView")
    );
    dispatch(
      fileActions.getAll(
        getFilesParams(
          {
            ...initFilesSearchFormState,
            CustomerId: item.globalId,
            Size: pageItemCount,
          },
          false,
          "",
          {}
        )
      ),
      `${translate("LoadingFiles")}...`
    );
    history.push("/files");
  };
  viewFilesByLegacyCustomer = (event, item) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount } = this.props;
    dispatch(
      actions.change("fileSearch", {
        ...initFilesSearchFormState,
        CustomerLegacyId: item.globalId,
        Size: pageItemCount,
        moreArrowIcon: "fa-chevron-up",
        toggleBtnTitle: "Hide advanced search options",
        showMoreHeight: "auto",
      })
    );
    dispatch(
      fileActions.getAll(
        getFilesParams(
          {
            ...initFilesSearchFormState,
            CustomerLegacyId: item.globalId,
            Size: pageItemCount,
          },
          false,
          "",
          {}
        ),
        `${translate("LoadingFiles")}...`
      )
    );
    history.push("/files");
  };
  viewDocsByCustomer = (event, item) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount } = this.props;
    dispatch(documentActions.clearDocuments());
    dispatch(
      actions.change("docSearch", {
        ...initDocsSearchFormState,
        CustomerId: item.globalId,
        Size: pageItemCount,
      })
    );
    dispatch(
      configActions.filterProjectByCustomerId(item.globalId, "documentsView")
    );
    dispatch(
      documentActions.getAll(
        getDocumentsWithoutPlatformSpecificParams({
          ...initDocsSearchFormState,
          CustomerId: item.globalId,
          Size: pageItemCount,
        }),
        `${translate("LoadingDocuments")}...`
      )
    );
    history.push("/documents");
  };

  viewDocsByLegacyCustomer = (event, item) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount } = this.props;
    dispatch(documentActions.clearDocuments());
    dispatch(
      actions.change("docSearch", {
        ...initDocsSearchFormState,
        CustomerLegacyId: item.globalId,
        Size: pageItemCount,
        moreArrowIcon: "fa-chevron-up",
        toggleBtnTitle: "Hide advanced search options",
        showMoreHeight: "auto",
      })
    );
    dispatch(
      documentActions.getAll(
        getDocumentsWithoutPlatformSpecificParams({
          ...initDocsSearchFormState,
          CustomerLegacyId: item.globalId,
          Size: pageItemCount,
        }),
        `${translate("LoadingDocuments")}...`
      )
    );
    history.push("/documents");
  };

  viewDashboardByCustomer = (event, item) => {
    event.preventDefault();
    const { dispatch, history, pageItemCount } = this.props;
    dispatch(
      actions.change("dashboardSearch", {
        ...initDashboardSearchFormState,
        CustomerId: item.globalId,
        Size: pageItemCount,
      })
    );
    dispatch(
      configActions.filterProjectByCustomerId(item.globalId, "dashboardView")
    );
    this.props.dispatch(
      dashboardActions.getLayout(
        getDocumentsWithoutPlatformSpecificParams({
          ...initDashboardSearchFormState,
          CustomerId: item.globalId,
          Size: pageItemCount,
        })
      )
    );
    history.push("/dashboard");
  };

  viewFilesByChannel = (event, item) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount } = this.props;
    dispatch(
      actions.change("fileSearch", {
        ...initFilesSearchFormState,
        ChannelName: item,
        Size: pageItemCount,
        moreArrowIcon: "fa-chevron-up",
        toggleBtnTitle: "Hide advanced search options",
        showMoreHeight: "auto",
      })
    );
    dispatch(
      fileActions.getAll(
        getFilesParams(
          {
            ...initFilesSearchFormState,
            ChannelName: item,
            Size: pageItemCount,
          },
          false,
          "",
          {}
        ),
        `${translate("LoadingFiles")}...`
      )
    );
    history.push("/files");
  };
  viewDocsByChannel = (event, item) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount } = this.props;
    dispatch(documentActions.clearDocuments());
    dispatch(
      actions.change("docSearch", {
        ...initDocsSearchFormState,
        ChannelName: item,
        Size: pageItemCount,
        moreArrowIcon: "fa-chevron-up",
        toggleBtnTitle: "Hide advanced search options",
        showMoreHeight: "auto",
      })
    );
    dispatch(
      documentActions.getAll(
        getDocumentsWithoutPlatformSpecificParams({
          ...initDocsSearchFormState,
          ChannelName: item,
          Size: pageItemCount,
        }),
        `${translate("LoadingDocuments")}...`
      )
    );
    history.push("/documents");
  };
  viewDocsByBatchID = (event, item) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount } = this.props;
    dispatch(documentActions.clearDocuments());
    dispatch(
      actions.change("docSearch", {
        ...initDocsSearchFormState,
        batch: item,
        Size: pageItemCount,
        moreArrowIcon: "fa-chevron-up",
        toggleBtnTitle: "Hide advanced search options",
        showMoreHeight: "auto",
      })
    );
    dispatch(
      documentActions.getAll(
        getDocumentsWithoutPlatformSpecificParams({
          ...initDocsSearchFormState,
          batch: item,
          Size: pageItemCount,
        }),
        `${translate("LoadingDocuments")}...`
      )
    );
    history.push("/documents");
  };

  viewConfig = (event, item) => {
    event.preventDefault();
    const { dispatch, selCustomerConfigReportsSize, history } = this.props;
    dispatch(configActions.setFilterStr("")); // reset filter
    dispatch(
      configActions.getProjectsByCustomerId(item.globalId, "configView")
    );
    dispatch(
      configActions.getReportsByCustomerId(
        item.globalId,
        1,
        selCustomerConfigReportsSize
      )
    );
    history.push("/customers");
  };

  viewFilesByProjectId = (event, item) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount } = this.props;
    dispatch(
      actions.change("fileSearch", {
        ...initFilesSearchFormState,
        CustomerId: item.globalId,
        ProjectId: item.foundProjectId,
        Size: pageItemCount,
      })
    );
    dispatch(
      configActions.filterProjectByCustomerId(item.globalId, "filesView")
    );
    dispatch(
      fileActions.getAll(
        getFilesParams(
          {
            ...initFilesSearchFormState,
            CustomerId: item.globalId,
            ProjectId: item.foundProjectId,
            Size: pageItemCount,
          },
          false,
          "",
          {}
        ),
        `${translate("LoadingFiles")}...`
      )
    );
    history.push("/files");
  };
  viewDocsByProjectId = (event, item) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount } = this.props;
    this.props.dispatch(documentActions.clearDocuments());
    dispatch(
      actions.change("docSearch", {
        ...initDocsSearchFormState,
        CustomerId: item.globalId,
        ProjectId: item.foundProjectId,
        Size: pageItemCount,
      })
    );
    dispatch(
      configActions.filterProjectByCustomerId(item.globalId, "documentsView")
    );
    dispatch(
      documentActions.getAll(
        getDocumentsWithoutPlatformSpecificParams({
          ...initDocsSearchFormState,
          CustomerId: item.globalId,
          ProjectId: item.foundProjectId,
          Size: pageItemCount,
        }),
        `${translate("LoadingDocuments")}...`
      )
    );
    history.push("/documents");
  };

  viewDashboardByProjectId = (event, item) => {
    event.preventDefault();
    const { dispatch, history, pageItemCount } = this.props;
    dispatch(
      actions.change("dashboardSearch", {
        ...initDashboardSearchFormState,
        CustomerId: item.globalId,
        ProjectId: item.foundProjectId,
        Size: pageItemCount,
      })
    );
    dispatch(
      configActions.filterProjectByCustomerId(item.globalId, "dashboardView")
    );
    this.props.dispatch(
      dashboardActions.getLayout(
        getDocumentsWithoutPlatformSpecificParams({
          ...initDashboardSearchFormState,
          CustomerId: item.globalId,
          ProjectId: item.foundProjectId,
          Size: pageItemCount,
        })
      )
    );
    history.push("/dashboard");
  };

  getDelayProbability = (deliverydata) => {
    const { translate } = this.props;
    //var channelName = "";
    if (deliverydata && deliverydata.length) {
      var errorIndex = -1;
      for (let i = 0; i < deliverydata.length; i++) {
        const docData = deliverydata[i];
        const delayProbability = docData.delayProbability;
        var elementErrorIndex = delayProbability
          ? delaysErrorStatus.indexOf(delayProbability)
          : -1;
        if (elementErrorIndex > errorIndex) {
          //channelName = docData.channel;
          errorIndex = elementErrorIndex;
        }
      }
      if (errorIndex > -1) {
        return (
          <span
            style={{
              marginLeft: "0.5em",
              color: "#dc3545",
              fontStyle: "italic",
            }}
          >
            {`${translate(
              delaysErrorStatus[errorIndex]
            )} possibility of the postal delay`}
          </span>
        );
      }
    }
    return null;
  };

  handleSwitchUser = (event, item) => {
    var params = {
      UserName: encodeURIComponent(item.UserId),
      Password: encodeURIComponent(random(10)),
      RememberMe: false,
    };
    const { dispatch } = this.props;
    axios.post("Account/SubLogin", params).then((response) => {
      var json = response.data;
      if (json.Errors && json.Errors.length) {
        console.log(json.Errors);
        return;
      }
      const { Status, PortalUserSettings } = json.Data;
      if (Status === "OK") {
        localStorage.setItem("LastLocationHash", "#/home");
        localStorage.setItem("LastLocationHashSearch", "");
        window.location.hash = "#/home";

        var subUserToken = response.request.getResponseHeader("portaltoken");
        if (!!subUserToken) {
          this.setState({
            isExternalUser: true,
            selectedTimeZone: {},
            selectedPageItemCount: {},
            selectedUser: {},
            externalCustomerId: PortalUserSettings.customerGlobalId,
            subUserToken: subUserToken,
          });
          const defaultSize = PortalUserSettings.pageItemCount || 20;

          // store to local storage
          dispatch(
            actions.change("fileSearch", {
              ...initFilesSearchFormState,
              Size: defaultSize,
            })
          );
          dispatch(
            actions.change("docSearch", {
              ...initDocsSearchFormState,
              Size: defaultSize,
            })
          );
          dispatch(
            actions.change("execReportSearch", {
              ...initExecReportsSearchFormState,
              Size: defaultSize,
            })
          );
          dispatch(
            actions.change("configReportSearch", {
              ...initConfigReportsSearchFormState,
              Size: defaultSize,
            })
          );
          dispatch(documentActions.setDocumentListParams("Size", defaultSize));

          dispatch(
            actions.change("dashboardSearch", {
              ...initDashboardSearchFormState,
            })
          );
          dispatch(
            actions.change("homeSearch", {
              ...initHomeSearchFormState,
            })
          );
          dispatch(
            userActions.switchToSubUser(PortalUserSettings, subUserToken)
          );
          dispatch(
            configActions.getProjectsByCustomerId(
              PortalUserSettings.customerGlobalId,
              null,
              true
            )
          );
          dispatch(configActions.getAllChannels({ ExternalView: true }));
        } else {
          // TODO: Show error
        }
      }
    });
  };
  viewDocsBySenderId = (event, item) => {
    event.preventDefault();
    const { dispatch, translate, history, pageItemCount } = this.props;
    dispatch(documentActions.clearDocuments());
    dispatch(
      actions.change("docSearch", {
        ...initDocsSearchFormState,
        CustomerId: item.globalId,
        Sender: item.foundSenderId,
        Size: pageItemCount,
      })
    );
    dispatch(
      configActions.filterProjectByCustomerId(item.globalId, "documentsView")
    );
    dispatch(
      documentActions.getAll(
        getDocumentsWithoutPlatformSpecificParams({
          ...initDocsSearchFormState,
          CustomerId: item.globalId,
          Sender: item.foundSenderId,
          Size: pageItemCount,
        }),
        `${translate("LoadingDocuments")}...`
      )
    );
    history.push("/documents");
  };

  handleOpenFilesFromFile = (file) => {
    let qData = {
      fileId: file.file.eventid,
      fidFs: file.fidfs,
    };
    var qs = require("qs");
    this.props.history.push("/files?" + qs.stringify(qData));
  };

  handleOpenFilesFromDoc = (doc) => {
    let qData = {
      fileId: doc.rooteventid,
    };
    if (doc.fidFs) {
      qData["fidFs"] = doc.fidFs;
    }
    var qs = require("qs");
    this.props.history.push("/files?" + qs.stringify(qData));
  };

  handleOpenDocument = (e, documentId) => {
    let qData = {
      DocUniqueId: documentId,
    };
    this.props.dispatch(documentActions.clearDocuments());
    var qs = require("qs");
    this.props.history.push("/documents?" + qs.stringify(qData));
  };

  navigateToFileDocs = (file) => {
    let qData = {
      file_event_id: file.file.eventid,
      fidfs: file.fidfs,
    };
    var qs = require("qs");
    this.props.history.push("/documents?" + qs.stringify(qData));
  };

  handleOpenFlow = (fileId) => {
    let qData = {
      id: fileId,
    };
    var qs = require("qs");
    this.props.history.push("/flows?" + qs.stringify(qData));
  };

  scrollToFilesByFileNameRes = (e) => {
    if (this.filesByFileNameResRef) {
      //window.scrollTo(0, this.filesByFileNameResRef.offsetTop);
      scrollToY(this.filesByFileNameResRef.offsetTop, 1500, "easeInOutQuint");
    }
  };

  scrollToFilesByCustomerIdRes = (e) => {
    if (this.filesByCustomerIdResRef) {
      //window.scrollTo(0, this.filesByCustomerIdResRef.offsetTop);
      scrollToY(this.filesByCustomerIdResRef.offsetTop, 1500, "easeInOutQuint");
    }
  };

  scrollToDocsByEBIDRes = (e) => {
    if (this.docsByEBIDResRef) {
      //window.scrollTo(0, this.docsByEBIDResRef.offsetTop);
      scrollToY(this.docsByEBIDResRef.offsetTop, 1500, "easeInOutQuint");
    }
  };

  scrollToDocsByDocNumRes = (e) => {
    if (this.docsByDocNumResRef) {
      //window.scrollTo(0, this.docsByDocNumResRef.offsetTop);
      scrollToY(this.docsByDocNumResRef.offsetTop, 1500, "easeInOutQuint");
    }
  };

  scrollToDocsBySenderRes = (e) => {
    if (this.docsBySenderResRef) {
      //window.scrollTo(0, this.docsBySenderResRef.offsetTop);
      scrollToY(this.docsBySenderResRef.offsetTop, 1500, "easeInOutQuint");
    }
  };

  scrollToDocsBySenderNameRes = (e) => {
    if (this.docsBySenderNameResRef) {
      scrollToY(this.docsBySenderNameResRef.offsetTop, 1500, "easeInOutQuint");
    }
  };

  scrollToDocsByReceiverRes = (e) => {
    if (this.docsByReceiverResRef) {
      scrollToY(this.docsByReceiverResRef.offsetTop, 1500, "easeInOutQuint");
    }
  };

  scrollToDocsByReceiverNameRes = (e) => {
    if (this.docsByReceiverNameResRef) {
      scrollToY(
        this.docsByReceiverNameResRef.offsetTop,
        1500,
        "easeInOutQuint"
      );
    }
  };

  scrollToBatchesRes = (e) => {
    if (this.batchesResRef) {
      scrollToY(this.batchesResRef.offsetTop, 1500, "easeInOutQuint");
    }
  };

  scrollToCustomerByProjectRes = (e) => {
    if (this.customersByProjectResRef) {
      //window.scrollTo(0, this.customersByProjectResRef.offsetTop);
      scrollToY(
        this.customersByProjectResRef.offsetTop,
        1500,
        "easeInOutQuint"
      );
    }
  };

  scrollToCustomerRes = (e) => {
    if (this.customersResRef) {
      //window.scrollTo(0, this.customersResRef.offsetTop);
      scrollToY(this.customersResRef.offsetTop, 1500, "easeInOutQuint");
    }
  };

  scrollToCustomerByUserRes = (e) => {
    if (this.customersByUserResRef) {
      //window.scrollTo(0, this.customersByUserResRef.offsetTop);
      scrollToY(this.customersByUserResRef.offsetTop, 1500, "easeInOutQuint");
    }
  };

  scrollToChannelsRes = (e) => {
    if (this.channelsResRef) {
      scrollToY(this.channelsResRef.offsetTop, 1500, "easeInOutQuint");
    }
  };

  scrollToCustomerBySenderRes = (e) => {
    if (this.customersBySenderResRef) {
      scrollToY(this.customersBySenderResRef.offsetTop, 1500, "easeInOutQuint");
    }
  };

  isProjectExist = (projectId) => {
    return (
      (this.props.allProjects || []).filter(
        (item) => item.projectId === projectId
      ).length > 0
    );
  };

  getSearchText = () => {
    const {
      smartSearchParams: { SearchText },
      smartSearchText,
      docsFilteredByEBID,
      docsFilteredByDocNum,

      customersFilteredByName,
      customersFilteredByUserName,
      customersFilteredByProjectName,
      customersFilteredBySender,

      docsFilteredBySender,
      docsFilteredByReceiver,
      docsFilteredByReceiverName,

      filesFilteredByFileName,
      filesFilteredByCustomerId,

      filteredChannels,
      batchesFiltered,

      loading_files,
      loading_files_customer,
      loading_docs,
      loading_docs_ebid,
      loading_docs_sender,
      loading_docs_sender_name,
      loading_docs_receiver,
      loading_docs_receiver_name,

      loading_batches,

      byEBID,
    } = this.props;
    let anyLoading =
      loading_files ||
      loading_files_customer ||
      loading_docs ||
      loading_docs_ebid ||
      loading_docs_sender ||
      loading_docs_sender_name ||
      loading_docs_receiver ||
      loading_docs_receiver_name ||
      loading_batches;

    let anyResultFound =
      !!customersFilteredByName ||
      !!customersFilteredByUserName ||
      !!customersFilteredByProjectName ||
      !!customersFilteredBySender ||
      !!docsFilteredByEBID ||
      !!docsFilteredByDocNum ||
      !!docsFilteredBySender ||
      !!docsFilteredByReceiver ||
      !!docsFilteredByReceiverName ||
      !!filesFilteredByFileName ||
      !!filesFilteredByCustomerId ||
      !!batchesFiltered ||
      !!filteredChannels;

    if (
      anyResultFound &&
      !anyLoading &&
      SearchText &&
      SearchText === smartSearchText &&
      SearchText.toString().trim().length > 1
    ) {
      let _searchText = SearchText.toString().trim();
      let _docIds = _searchText.split(","),
        _ids = [];
      if (_docIds.length > 1) {
        _docIds.forEach((id, index) => {
          if (id.trim().length) {
            //_ids.push(id.trim());
            const regex = new RegExp(id.trim(), "i");
            var _found = (docsFilteredByEBID || []).filter((item) =>
              byEBID
                ? item.ebid === id.trim()
                : item.docnodeid && item.docnodeid.match(regex)
            )[0];

            if (!_found) {
              _found = (docsFilteredByDocNum || []).filter(
                (item) => item.documentNr && item.documentNr.match(regex)
              )[0];
            }

            if (_found) {
              _ids.push(`<span style="color:green">${id}</span>`);
            } else {
              _ids.push(`<span style="color:red">${id}</span>`);
            }
          } else {
            _ids.push(`${id}`);
          }
        });
        if (_ids.length) {
          return `${_ids.join(",")}`;
        }
      } else {
        return SearchText;
      }
    }
    return SearchText;
  };

  onSearchTextKeyDown = (event) => {
    if (event.key === "Enter") {
      this.onSearchClick(event);
    }
  };

  componentDidMount = () => {
    const { allCustomers, dispatch } = this.props;
    if (!allCustomers || allCustomers.length === 0) {
      dispatch(configActions.getAllCustomers());
    }
    this.contentEditable &&
      this.contentEditable.current &&
      this.contentEditable.current.focus &&
      this.contentEditable.current.focus();
  };

  render() {
    const {
      smartSearchParams: { SearchText },
      translate,

      customersFilteredByName,
      customersFilteredByUserName,
      customersFilteredByProjectName,
      customersFilteredBySender,

      docsFilteredByEBID,

      docsFilteredByDocNum,

      docsFilteredBySender,
      docsFilteredBySenderName,

      docsFilteredByReceiver,
      docsFilteredByReceiverName,

      filesFilteredByFileName,
      filesFilteredByCustomerId,

      filteredChannels,

      filesShowMore,
      filesShowMoreByCustomerId,
      docsShowMore,
      docsShowMoreSender,
      docsShowMoreSenderName,

      docsShowMoreReceiver,
      docsShowMoreReceiverName,

      smartSearchText,

      loading_files,
      loading_files_customer,
      loading_docs,
      loading_docs_ebid,
      loading_docs_sender,
      loading_docs_sender_name,
      loading_docs_receiver,

      loading_docs_receiver_name,

      loading_batches,
      batchesFiltered,

      byEBID,
    } = this.props;
    let anyResultFound =
      !!customersFilteredByName ||
      !!customersFilteredByUserName ||
      !!customersFilteredByProjectName ||
      !!customersFilteredBySender ||
      !!docsFilteredByEBID ||
      !!docsFilteredByDocNum ||
      !!docsFilteredBySender ||
      !!docsFilteredBySenderName ||
      !!docsFilteredByReceiver ||
      !!docsFilteredByReceiverName ||
      !!filesFilteredByFileName ||
      !!filesFilteredByCustomerId ||
      !!batchesFiltered ||
      !!filteredChannels;

    let notFoundEBID = [];
    if (byEBID) {
      let _searchText = smartSearchText.toString().trim();
      let _docIds = _searchText.split(",");
      _docIds.forEach((id, index) => {
        if (id.trim().length) {
          var _found = (docsFilteredByEBID || []).filter(
            (item) => item.ebid === id.trim()
          )[0];
          if (!_found) {
            notFoundEBID.push(id);
          }
        }
      });
    }
    return (
      <div id="smartSearch_view">
        <div
          className="sticky-search-top w-100 top_search"
          style={{ textAlign: "center", padding: 0 }}
        >
          <Form className="horizSearchForm" name="horizSearchForm">
            <div
              className="search_top container"
              style={{ padding: "2.5rem 0 1rem" }}
            >
              <div className="d-flex flex-row min-to-column">
                <div className="min-width-to-100 mid-width-to-50 search_menu_item input-text-div">
                  <div className="input-group min-top-input-borders-set custom2 exec-report-ext-search">
                    <span className="fa fa-search custom3" aria-hidden="true" />
                    <ContentEditable
                      innerRef={this.contentEditable}
                      data-title="Search by file name, document num, customer, project, user, EBID, date, channel, state"
                      className={`form-control editable-input ${
                        SearchText && SearchText.length > 0
                          ? ""
                          : "show-placeholder"
                      }`}
                      html={this.getSearchText(SearchText)} // innerHTML of the editable div
                      disabled={false} // use true to disable editing
                      onKeyDown={this.onSearchTextKeyDown}
                      onChange={this.onSearchTextFieldChange} // handle innerHTML change
                    />
                    {this.state.showSearchWarning && (
                      <div className="search-alert">
                        Please enter at least 2 letters to start search
                        <button
                          type="button"
                          className="close"
                          aria-label="Close"
                          style={{ backgroundColor: "transparent" }}
                          onClick={this.onSearchWarningDismiss}
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                    )}
                    {this.state.showSearchWarning2 && (
                      <div className="search-alert">
                        The maximum comma seperated items for search is 20 items
                        <button
                          type="button"
                          className="close"
                          aria-label="Close"
                          style={{ backgroundColor: "transparent" }}
                          onClick={this.onSearchWarning2Dismiss}
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="search_menu_item mid-width-to-50 search-btn-div"
                  style={{ marginRight: 0 }}
                >
                  <div className="text-center main-button-container">
                    <Button
                      color="primary"
                      className="btn-posti-default"
                      onClick={this.onSearchClick}
                    >
                      <span>{translate("Search")}</span>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            {anyResultFound && (
              <div className="col-lg-12 col-md-12 col-sm-12 col-12 hidden-sm-screen-search">
                <div
                  className="row"
                  style={{ borderBottom: "solid 1px #CCCCCC" }}
                >
                  <div className="col-lg-12 col-md-12 col-sm-12 col-sm-12 col-12">
                    <div
                      className="row justify-content-center top_more_style"
                      style={{ marginTop: ".5rem" }}
                    >
                      <div style={{ maxWidth: "100%" }}>
                        <div className="menu-group">
                          <div className="right-label">Files by</div>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={`nav-label ${
                              filesFilteredByFileName &&
                              filesFilteredByFileName.length > 0
                                ? "success"
                                : "disabled"
                            } ${loading_files ? "loading" : ""}`}
                            onClick={this.scrollToFilesByFileNameRes}
                          >
                            {translate("Name")}
                          </a>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={`nav-label ${
                              filesFilteredByCustomerId &&
                              filesFilteredByCustomerId.length > 0
                                ? "success"
                                : "disabled"
                            } ${loading_files_customer ? "loading" : ""}`}
                            onClick={this.scrollToFilesByCustomerIdRes}
                          >
                            {translate("Pl. Specific ID")}
                          </a>
                        </div>
                        <div
                          className="menu-group"
                          style={{ marginLeft: "0.85714286em" }}
                        >
                          <div className="right-label">Documents by</div>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={`nav-label ${
                              docsFilteredByDocNum &&
                              docsFilteredByDocNum.length > 0
                                ? "success"
                                : "disabled"
                            } ${loading_docs ? "loading" : ""}`}
                            onClick={this.scrollToDocsByDocNumRes}
                          >
                            {translate("Nr")}
                          </a>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={`nav-label ${
                              docsFilteredByEBID &&
                              docsFilteredByEBID.length > 0
                                ? "success"
                                : "disabled"
                            } ${loading_docs_ebid ? "loading" : ""}`}
                            onClick={this.scrollToDocsByEBIDRes}
                          >
                            {translate("ID")}
                          </a>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={`nav-label ${
                              docsFilteredBySender &&
                              docsFilteredBySender.length > 0
                                ? "success"
                                : "disabled"
                            } ${loading_docs_sender ? "loading" : ""}`}
                            onClick={this.scrollToDocsBySenderRes}
                          >
                            {translate("Sender")} ID
                          </a>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={`nav-label ${
                              docsFilteredBySenderName &&
                              docsFilteredBySenderName.length > 0
                                ? "success"
                                : "disabled"
                            } ${loading_docs_sender_name ? "loading" : ""}`}
                            onClick={this.scrollToDocsBySenderNameRes}
                          >
                            {translate("Sender")} {translate("Name")}
                          </a>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={`nav-label ${
                              docsFilteredByReceiver &&
                              docsFilteredByReceiver.length > 0
                                ? "success"
                                : "disabled"
                            } ${loading_docs_receiver ? "loading" : ""}`}
                            onClick={this.scrollToDocsByReceiverRes}
                          >
                            {translate("Receiver")} ID
                          </a>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={`nav-label ${
                              docsFilteredByReceiverName &&
                              docsFilteredByReceiverName.length > 0
                                ? "success"
                                : "disabled"
                            } ${loading_docs_receiver_name ? "loading" : ""}`}
                            onClick={this.scrollToDocsByReceiverNameRes}
                          >
                            {translate("Receiver")} {translate("Name")}
                          </a>
                        </div>
                        <div
                          className="menu-group"
                          style={{ marginLeft: "0.85714286em" }}
                        >
                          <div className="right-label">Config</div>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={`nav-label ${
                              customersFilteredByName &&
                              customersFilteredByName.length > 0
                                ? "success"
                                : "disabled"
                            }`}
                            onClick={this.scrollToCustomerRes}
                          >
                            {translate("Customers")}
                          </a>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={`nav-label ${
                              customersFilteredByProjectName &&
                              customersFilteredByProjectName.length > 0
                                ? "success"
                                : "disabled"
                            }`}
                            onClick={this.scrollToCustomerByProjectRes}
                          >
                            {translate("Projects")}
                          </a>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={`nav-label ${
                              customersFilteredByUserName &&
                              customersFilteredByUserName.length > 0
                                ? "success"
                                : "disabled"
                            }`}
                            onClick={this.scrollToCustomerByUserRes}
                          >
                            {translate("Users")}
                          </a>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={`nav-label ${
                              customersFilteredBySender &&
                              customersFilteredBySender.length > 0
                                ? "success"
                                : "disabled"
                            }`}
                            onClick={this.scrollToCustomerBySenderRes}
                          >
                            {translate("Senders")}
                          </a>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={`nav-label ${
                              filteredChannels && filteredChannels.length > 0
                                ? "success"
                                : "disabled"
                            }`}
                            onClick={this.scrollToChannelsRes}
                          >
                            {translate("Channels")}
                          </a>
                        </div>
                        <div
                          className="menu-group"
                          style={{ marginLeft: "0.85714286em" }}
                        >
                          <div className="right-label">Other</div>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={`nav-label ${
                              batchesFiltered && batchesFiltered.length > 0
                                ? "success"
                                : "disabled"
                            } ${loading_batches ? "loading" : ""}`}
                            onClick={this.scrollToBatchesRes}
                          >
                            {translate("Batches")}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Form>
        </div>
        <div
          id="smartSearch_content"
          style={{ padding: "1em" }}
          className="fill col-lg-12 col-md-12 col-sm-12 col-xs-12"
        >
          <Container style={{ padding: "0 1em" }}>
            {!anyResultFound && (
              <div className="placeholder-segment">
                <div className="placeholder-header">
                  <i className="fa fa-search" />
                  <p style={{ lineHeight: "1.6em" }}>
                    {translate("SmartSearchIntroText")}
                  </p>
                </div>
              </div>
            )}
            {filesFilteredByFileName && (
              <div
                className="row search-result-panel"
                ref={(el) => {
                  this.filesByFileNameResRef = el;
                }}
              >
                <Col
                  xs="2"
                  className="hidden-sm-screen-search"
                  style={{ margin: "0.5em 0" }}
                >
                  <StickyContainer style={{ height: "100%" }}>
                    <Sticky topOffset={-180} bottomOffset={-210}>
                      {({ style }) => (
                        <div
                          className="side-header"
                          style={{ ...style, top: "180px" }}
                        >
                          {translate("Files")}
                        </div>
                      )}
                    </Sticky>
                    <div className="desc-header">
                      {translate("FilesSmartSearchDesc")}
                    </div>
                  </StickyContainer>
                </Col>
                <div
                  className="side-header ls-screen-hidden-search"
                  style={{ padding: "0.5em" }}
                >
                  {translate("Files")}
                </div>
                <Col xs="10">
                  {loading_files ? (
                    <div className="smart-search-loading">
                      <div
                        className="spinner-border"
                        style={{ float: "left" }}
                      />
                      <div className="smart-search-loading-text">
                        Searching files by file name...
                      </div>
                    </div>
                  ) : filesFilteredByFileName.length > 0 ? (
                    filesFilteredByFileName.map((item, index) => (
                      <Row
                        className={
                          "sub-search-panel row-status-" + item.status.id
                        }
                        style={{ marginTop: "0.1em", borderLeftWidth: "3px" }}
                        key={index}
                      >
                        <Col style={{ padding: 0 }}>
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="info"
                                data-delay-update={500}
                                data-for={`filesFilteredByFileName-${index}`}
                              >
                                {item.mode === "test" ? (
                                  <span>
                                    <i>[TEST]</i>{" "}
                                    <b>
                                      {highlight(
                                        item.file.shortname,
                                        smartSearchText,
                                        true
                                      )}
                                    </b>
                                  </span>
                                ) : (
                                  <span>
                                    <b>
                                      {highlight(
                                        item.file.shortname,
                                        smartSearchText
                                      )}
                                    </b>
                                  </span>
                                )}
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>{" "}
                              {item.customer || item.flow ? (
                                <span>
                                  {item.customer && (
                                    <span>
                                      Customer:{" "}
                                      <strong
                                        className="finger underline"
                                        data-tip
                                        data-type="info"
                                        data-delay-update={500}
                                        data-for={`filesFilteredByFileName-customer${
                                          isLegacyCustomer(item.customer)
                                            ? "-legacy"
                                            : ""
                                        }-${index}`}
                                      >
                                        {item.customer}
                                        {isMobile && (
                                          <i className="fas fa-location-arrow button-list-icon" />
                                        )}
                                      </strong>{" "}
                                    </span>
                                  )}
                                  {item.flow && (
                                    <span>
                                      Project:{" "}
                                      {this.isProjectExist(item.flow) ? (
                                        <strong
                                          className="finger underline"
                                          data-tip
                                          data-type="info"
                                          data-delay-update={500}
                                          data-for={`filesFilteredByFileName-project-${index}`}
                                        >
                                          {item.flow}
                                          {isMobile && (
                                            <i className="fas fa-location-arrow button-list-icon" />
                                          )}
                                        </strong>
                                      ) : (
                                        <i>{item.flow}</i>
                                      )}
                                    </span>
                                  )}
                                </span>
                              ) : null}
                            </div>
                            <div className="panel-body">
                              <div>
                                <span style={{ marginLeft: "1em" }}>
                                  Delivered:{" "}
                                  {item.completiontime
                                    ? moment
                                        .utc(
                                          item.completiontime,
                                          moment.ISO_8601
                                        )
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>{" "}
                                <span>
                                  Arrived:{" "}
                                  {item.file.timestamp
                                    ? moment
                                        .utc(
                                          item.file.timestamp,
                                          moment.ISO_8601
                                        )
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>
                              </div>
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type={"info"}
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`filesFilteredByFileName-${index}`}
                              >
                                <Button
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenFilesFromFile(item)
                                  }
                                >
                                  {translate("View file")}
                                </Button>
                                {item.docs > 0 ? (
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.navigateToFileDocs(item)
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>
                                ) : null}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenFlow(item.file.eventid)
                                  }
                                >
                                  {translate("View flow")}
                                </Button>
                              </ReactTooltip>
                              {isLegacyCustomer(item.customer) ? (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`filesFilteredByFileName-customer-legacy-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>
                                </ReactTooltip>
                              ) : (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`filesFilteredByFileName-customer-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewConfig(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("Configure")}
                                  </Button>
                                </ReactTooltip>
                              )}
                              {this.isProjectExist(item.flow) && (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"light"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`filesFilteredByFileName-project-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.flow,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.flow,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.flow,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                </ReactTooltip>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <div className="empty-result">
                      {translate("Show more files")}
                      {translate("NoFilesMatchedFileName")}
                    </div>
                  )}
                  {filesFilteredByFileName.length > 0 && filesShowMore && (
                    <button
                      style={{ margin: "5px" }}
                      type="button"
                      className="btn btn-secondary"
                      onClick={this.showMoreFiles}
                    >
                      {translate("Show more files")}
                    </button>
                  )}
                </Col>
              </div>
            )}
            {filesFilteredByCustomerId && (
              <div
                className="row search-result-panel"
                ref={(el) => {
                  this.filesByCustomerIdResRef = el;
                }}
              >
                <Col
                  xs="2"
                  className="hidden-sm-screen-search"
                  style={{ margin: "0.5em 0" }}
                >
                  <StickyContainer style={{ height: "100%" }}>
                    <Sticky topOffset={-180} bottomOffset={-210}>
                      {({ style }) => (
                        <div
                          className="side-header"
                          style={{ ...style, top: "180px" }}
                        >
                          {translate("FilesByCustomerID")}
                        </div>
                      )}
                    </Sticky>
                    <div className="desc-header">
                      {translate("FilesByCustomerIDSearchDesc")}
                    </div>
                  </StickyContainer>
                </Col>
                <div
                  className="side-header ls-screen-hidden-search"
                  style={{ padding: "0.5em" }}
                >
                  {translate("FilesByCustomerID")}
                </div>
                <Col xs="10">
                  {loading_files_customer ? (
                    <div className="smart-search-loading">
                      <div
                        className="spinner-border"
                        style={{ float: "left" }}
                      />
                      <div className="smart-search-loading-text">
                        {translate("FilesByCustomerIDLoading")}...
                      </div>
                    </div>
                  ) : filesFilteredByCustomerId.length > 0 ? (
                    filesFilteredByCustomerId.map((item, index) => (
                      <Row
                        className={
                          "sub-search-panel row-status-" + item.status.id
                        }
                        style={{ marginTop: "0.1em", borderLeftWidth: "3px" }}
                        key={index}
                      >
                        <Col style={{ padding: 0 }}>
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <strong>
                                {highlight(
                                  item.customer,
                                  smartSearchText && smartSearchText.trim()
                                )}{" "}
                              </strong>
                              FileName:{" "}
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="info"
                                data-delay-update={500}
                                data-for={`filesFilteredByCustomerId-${index}`}
                              >
                                {item.mode === "test" ? (
                                  <span>
                                    <i>[TEST]</i> <b>{item.file.shortname}</b>
                                  </span>
                                ) : (
                                  <span>
                                    <b>{item.file.shortname}</b>
                                  </span>
                                )}
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>{" "}
                              {item.customer || item.flow ? (
                                <span>
                                  {item.customer && (
                                    <span>
                                      Customer:{" "}
                                      <strong
                                        className="finger underline"
                                        data-tip
                                        data-type="info"
                                        data-delay-update={500}
                                        data-for={`filesFilteredByCustomerId-customer${
                                          isLegacyCustomer(item.customer)
                                            ? "-legacy"
                                            : ""
                                        }-${index}`}
                                      >
                                        {item.customer}
                                        {isMobile && (
                                          <i className="fas fa-location-arrow button-list-icon" />
                                        )}
                                      </strong>{" "}
                                    </span>
                                  )}
                                  {item.flow && (
                                    <span>
                                      Project:{" "}
                                      {this.isProjectExist(item.flow) ? (
                                        <strong
                                          className="finger underline"
                                          data-tip
                                          data-type="info"
                                          data-delay-update={500}
                                          data-for={`filesFilteredByCustomerId-project-${index}`}
                                        >
                                          {item.flow}
                                          {isMobile && (
                                            <i className="fas fa-location-arrow button-list-icon" />
                                          )}
                                        </strong>
                                      ) : (
                                        <i>{item.flow}</i>
                                      )}
                                    </span>
                                  )}
                                </span>
                              ) : null}
                            </div>
                            <div className="panel-body">
                              <div>
                                <span style={{ marginLeft: "1em" }}>
                                  Delivered:{" "}
                                  {item.completiontime
                                    ? moment
                                        .utc(
                                          item.completiontime,
                                          moment.ISO_8601
                                        )
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>{" "}
                                <span>
                                  Arrived:{" "}
                                  {item.file.timestamp
                                    ? moment
                                        .utc(
                                          item.file.timestamp,
                                          moment.ISO_8601
                                        )
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>
                              </div>
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type={"info"}
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`filesFilteredByCustomerId-${index}`}
                              >
                                <Button
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenFilesFromFile(item)
                                  }
                                >
                                  {translate("View file")}
                                </Button>{" "}
                                {item.docs > 0 ? (
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.navigateToFileDocs(item)
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>
                                ) : null}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenFlow(item.file.eventid)
                                  }
                                >
                                  {translate("View flow")}
                                </Button>
                              </ReactTooltip>

                              {isLegacyCustomer(item.customer) ? (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`filesFilteredByCustomerId-customer-legacy-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>
                                </ReactTooltip>
                              ) : (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`filesFilteredByCustomerId-customer-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewConfig(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("Configure")}
                                  </Button>
                                </ReactTooltip>
                              )}
                              {this.isProjectExist(item.flow) && (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"light"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`filesFilteredByCustomerId-project-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.flow,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.flow,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.flow,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                </ReactTooltip>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <div className="empty-result">
                      {translate("NoFilesMatchedCustomerID")}
                    </div>
                  )}
                  {filesFilteredByCustomerId.length > 0 &&
                    filesShowMoreByCustomerId && (
                      <button
                        style={{ margin: "5px" }}
                        type="button"
                        className="btn btn-secondary"
                        onClick={this.showMoreFilesByCustomerId}
                      >
                        {translate("Show more files")}
                      </button>
                    )}
                </Col>
              </div>
            )}
            {docsFilteredByEBID && (
              <div
                className="row search-result-panel"
                ref={(el) => {
                  this.docsByEBIDResRef = el;
                }}
              >
                <Col
                  xs="2"
                  className="hidden-sm-screen-search"
                  style={{ margin: "0.5em 0" }}
                >
                  <StickyContainer style={{ height: "100%" }}>
                    <Sticky topOffset={-180} bottomOffset={-210}>
                      {({ style }) => (
                        <div
                          className="side-header"
                          style={{ ...style, top: "180px" }}
                        >
                          {byEBID ? "EBID" : translate("DocumentsByID")}
                        </div>
                      )}
                    </Sticky>
                    <div className="desc-header">
                      {byEBID
                        ? translate("DocumentsByEBIDLoaded")
                        : translate("DocumentsByIDLoaded")}
                    </div>
                  </StickyContainer>
                </Col>
                <div
                  className="side-header ls-screen-hidden-search"
                  style={{ padding: "0.5em" }}
                >
                  {byEBID ? "EBID" : translate("DocumentsByID")}
                </div>
                <Col xs="10">
                  {loading_docs_ebid ? (
                    <div className="smart-search-loading">
                      <div
                        className="spinner-border"
                        style={{ float: "left" }}
                      />
                      <div className="smart-search-loading-text">
                        {`Searching documents by ${
                          byEBID ? "EBID" : translate("Document ID")
                        }`}
                        ...
                      </div>
                    </div>
                  ) : docsFilteredByEBID.length > 0 ? (
                    docsFilteredByEBID.map((item, index) => (
                      <Row
                        className={"sub-search-panel row-status-" + item.status}
                        style={{ marginTop: "0.1em", borderLeftWidth: "3px" }}
                        key={index}
                      >
                        <Col style={{ padding: 0 }}>
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <strong
                                className="finger highlight"
                                data-tip
                                data-type="light"
                                data-delay-update={500}
                                data-for={`docsFilteredByEBID-${index}`}
                              >
                                {byEBID
                                  ? item.ebid
                                  : item.docnodeid
                                  ? item.docnodeid.split("::")[2]
                                  : "[Unknown]"}
                              </strong>{" "}
                              {item.customer || item.project ? (
                                <span>
                                  {item.customer && (
                                    <span>
                                      Customer:{" "}
                                      <strong
                                        className="finger underline"
                                        data-tip
                                        data-type="info"
                                        data-delay-update={500}
                                        data-for={`docsFilteredByEBID-customer${
                                          isLegacyCustomer(item.customer)
                                            ? "-legacy"
                                            : ""
                                        }-${index}`}
                                      >
                                        {item.customer}
                                        {isMobile && (
                                          <i className="fas fa-location-arrow button-list-icon" />
                                        )}
                                      </strong>{" "}
                                    </span>
                                  )}
                                  {item.project && (
                                    <span>
                                      Project:{" "}
                                      {this.isProjectExist(item.project) ? (
                                        <strong
                                          className="finger underline"
                                          data-tip
                                          data-type="info"
                                          data-delay-update={500}
                                          data-for={`docsFilteredByEBID-project-${index}`}
                                        >
                                          {item.project}
                                          {isMobile && (
                                            <i className="fas fa-location-arrow button-list-icon" />
                                          )}
                                        </strong>
                                      ) : (
                                        <i>{item.project}</i>
                                      )}
                                    </span>
                                  )}
                                </span>
                              ) : null}
                            </div>
                            <div className="panel-body">
                              <div>
                                <span>
                                  Arrived:{" "}
                                  {item.fileArrivalTs
                                    ? moment
                                        .utc(
                                          item.fileArrivalTs,
                                          moment.ISO_8601
                                        )
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>{" "}
                                <span style={{ marginLeft: "1em" }}>
                                  Delivered:{" "}
                                  {item.timestamp
                                    ? moment
                                        .utc(item.timestamp, moment.ISO_8601)
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>
                                {this.getDelayProbability(item.deliverydata)}
                              </div>
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type="light"
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`docsFilteredByEBID-${index}`}
                              >
                                <Button
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenFilesFromDoc(item)
                                  }
                                >
                                  {translate("View file")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenDocument(e, item.docnodeid)
                                  }
                                >
                                  {translate("View document")}
                                </Button>
                              </ReactTooltip>
                              {isLegacyCustomer(item.customer) ? (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredByEBID-customer-legacy-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>
                                </ReactTooltip>
                              ) : (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredByEBID-customer-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewConfig(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("Configure")}
                                  </Button>
                                </ReactTooltip>
                              )}
                              {this.isProjectExist(item.project) && (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"light"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredByEBID-project-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                </ReactTooltip>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <div className="empty-result">
                      {`It seems no documents match the ${
                        byEBID ? "EBID" : translate("Document ID")
                      }`}
                    </div>
                  )}
                </Col>
              </div>
            )}
            {docsFilteredByDocNum && (
              <div
                className="row search-result-panel"
                ref={(el) => {
                  this.docsByDocNumResRef = el;
                }}
              >
                <Col
                  xs="2"
                  className="hidden-sm-screen-search"
                  style={{ margin: "0.5em 0" }}
                >
                  <StickyContainer style={{ height: "100%" }}>
                    <Sticky topOffset={-180} bottomOffset={-210}>
                      {({ style }) => (
                        <div
                          className="side-header"
                          style={{ ...style, top: "180px" }}
                        >
                          {translate("Documents")}
                        </div>
                      )}
                    </Sticky>
                    <div className="desc-header">
                      {translate("DocumentsSmartSearchDesc")}
                    </div>
                  </StickyContainer>
                </Col>
                <div
                  className="side-header ls-screen-hidden-search"
                  style={{ padding: "0.5em" }}
                >
                  {translate("Documents")}
                </div>
                <Col xs="10">
                  {loading_docs ? (
                    <div className="smart-search-loading">
                      <div
                        className="spinner-border"
                        style={{ float: "left" }}
                      />
                      <div className="smart-search-loading-text">
                        {translate("SearchingDocumentsByDocumentNumber")}...
                      </div>
                    </div>
                  ) : docsFilteredByDocNum.length > 0 ? (
                    docsFilteredByDocNum.map((item, index) => (
                      <Row
                        className={"sub-search-panel row-status-" + item.status}
                        style={{ marginTop: "0.1em", borderLeftWidth: "3px" }}
                        key={index}
                      >
                        <Col style={{ padding: 0 }}>
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="light"
                                data-delay-update={500}
                                data-for={`docsFilteredByDocNum-${index}`}
                              >
                                {item.mode === "test" && (
                                  <span>
                                    <i>[TEST]</i>{" "}
                                  </span>
                                )}{" "}
                                {highlight(
                                  item.documentNr,
                                  smartSearchText && smartSearchText.trim(),
                                  true
                                ) || <i>[Not defined]</i>}
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>{" "}
                              {item.customer || item.project ? (
                                <span>
                                  {item.customer && (
                                    <span>
                                      Customer:{" "}
                                      <strong
                                        className="finger underline"
                                        data-tip
                                        data-type="info"
                                        data-delay-update={500}
                                        data-for={`docsFilteredByDocNum-customer${
                                          isLegacyCustomer(item.customer)
                                            ? "-legacy"
                                            : ""
                                        }-${index}`}
                                      >
                                        {item.customer}
                                        {isMobile && (
                                          <i className="fas fa-location-arrow button-list-icon" />
                                        )}
                                      </strong>{" "}
                                    </span>
                                  )}
                                  {item.project && (
                                    <span>
                                      Project:{" "}
                                      {this.isProjectExist(item.project) ? (
                                        <strong
                                          className="finger underline"
                                          data-tip
                                          data-type="info"
                                          data-delay-update={500}
                                          data-for={`docsFilteredByDocNum-project-${index}`}
                                        >
                                          {item.project}
                                          {isMobile && (
                                            <i className="fas fa-location-arrow button-list-icon" />
                                          )}
                                        </strong>
                                      ) : (
                                        <i>{item.project}</i>
                                      )}
                                    </span>
                                  )}
                                </span>
                              ) : null}
                            </div>
                            <div className="panel-body">
                              <div>
                                <span style={{ marginLeft: "1em" }}>
                                  Delivered:{" "}
                                  {item.timestamp
                                    ? moment
                                        .utc(item.timestamp, moment.ISO_8601)
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>{" "}
                                <span>
                                  Arrived:{" "}
                                  {item.fileArrivalTs
                                    ? moment
                                        .utc(
                                          item.fileArrivalTs,
                                          moment.ISO_8601
                                        )
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>
                                {this.getDelayProbability(item.deliverydata)}
                              </div>
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type={"light"}
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`docsFilteredByDocNum-${index}`}
                              >
                                <Button
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenFilesFromDoc(item)
                                  }
                                >
                                  {translate("View file")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenDocument(e, item.docnodeid)
                                  }
                                >
                                  {translate("View document")}
                                </Button>
                              </ReactTooltip>
                              {isLegacyCustomer(item.customer) ? (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredByDocNum-customer-legacy-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>
                                </ReactTooltip>
                              ) : (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredByDocNum-customer-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewConfig(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("Configure")}
                                  </Button>
                                </ReactTooltip>
                              )}
                              {this.isProjectExist(item.project) && (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"light"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredByDocNum-project-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                </ReactTooltip>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <div className="empty-result">
                      {translate("NoDocumentsMatchedFileName")}
                    </div>
                  )}
                  {docsFilteredByDocNum.length > 0 && docsShowMore && (
                    <button
                      style={{ margin: "5px" }}
                      type="button"
                      className="btn btn-secondary"
                      onClick={this.showMoreDocs}
                    >
                      {translate("Show more documents")}
                    </button>
                  )}
                </Col>
              </div>
            )}
            {docsFilteredBySender && (
              <div
                className="row search-result-panel"
                ref={(el) => {
                  this.docsBySenderResRef = el;
                }}
              >
                <Col
                  xs="2"
                  className="hidden-sm-screen-search"
                  style={{ margin: "0.5em 0" }}
                >
                  <StickyContainer style={{ height: "100%" }}>
                    <Sticky topOffset={-180} bottomOffset={-210}>
                      {({ style }) => (
                        <div
                          className="side-header"
                          style={{ ...style, top: "180px" }}
                        >
                          {translate("Documents by Sender ID")}
                        </div>
                      )}
                    </Sticky>
                    <div className="desc-header">
                      {translate(
                        "Documents are searched by the beginning of Sender name ID."
                      )}
                    </div>
                  </StickyContainer>
                </Col>
                <div
                  className="side-header ls-screen-hidden-search"
                  style={{ padding: "0.5em" }}
                >
                  {translate("Documents by Sender")}
                </div>
                <Col xs="10">
                  {loading_docs_sender ? (
                    <div className="smart-search-loading">
                      <div
                        className="spinner-border"
                        style={{ float: "left" }}
                      />
                      <div className="smart-search-loading-text">
                        {translate("Searching documents by Sender ID")}...
                      </div>
                    </div>
                  ) : docsFilteredBySender.length > 0 ? (
                    docsFilteredBySender.map((item, index) => (
                      <Row
                        className={"sub-search-panel row-status-" + item.status}
                        style={{ marginTop: "0.1em", borderLeftWidth: "3px" }}
                        key={index}
                      >
                        <Col style={{ padding: 0 }}>
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <strong>
                                {item.senderName
                                  ? highlight(
                                      item.senderName,
                                      smartSearchText && smartSearchText.trim()
                                    )
                                  : null}
                                {item.senderName && " "}
                                {item.sender
                                  ? highlight(
                                      "[" + item.sender + "]",
                                      smartSearchText && smartSearchText.trim()
                                    )
                                  : ""}
                              </strong>{" "}
                              Document Nr:{" "}
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="light"
                                data-delay-update={500}
                                data-for={`docsFilteredBySender-${index}`}
                              >
                                {item.mode === "test" && (
                                  <span>
                                    <i>[TEST]</i>{" "}
                                  </span>
                                )}{" "}
                                {item.documentNr || <i>[Not defined]</i>}
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>{" "}
                              {item.customer || item.project ? (
                                <span>
                                  {item.customer && (
                                    <span>
                                      Customer:{" "}
                                      <strong
                                        className="finger underline"
                                        data-tip
                                        data-type="info"
                                        data-delay-update={500}
                                        data-for={`docsFilteredBySender-customer${
                                          isLegacyCustomer(item.customer)
                                            ? "-legacy"
                                            : ""
                                        }-${index}`}
                                      >
                                        {item.customer}
                                        {isMobile && (
                                          <i className="fas fa-location-arrow button-list-icon" />
                                        )}
                                      </strong>{" "}
                                    </span>
                                  )}
                                  {item.project && (
                                    <span>
                                      Project:{" "}
                                      {this.isProjectExist(item.project) ? (
                                        <strong
                                          className="finger underline"
                                          data-tip
                                          data-type="info"
                                          data-delay-update={500}
                                          data-for={`docsFilteredBySender-project-${index}`}
                                        >
                                          {item.project}
                                          {isMobile && (
                                            <i className="fas fa-location-arrow button-list-icon" />
                                          )}
                                        </strong>
                                      ) : (
                                        <i>{item.project}</i>
                                      )}
                                    </span>
                                  )}
                                </span>
                              ) : null}
                            </div>
                            <div className="panel-body">
                              <div>
                                <span style={{ marginLeft: "1em" }}>
                                  Delivered:{" "}
                                  {item.timestamp
                                    ? moment
                                        .utc(item.timestamp, moment.ISO_8601)
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>{" "}
                                <span>
                                  Arrived:{" "}
                                  {item.fileArrivalTs
                                    ? moment
                                        .utc(
                                          item.fileArrivalTs,
                                          moment.ISO_8601
                                        )
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>
                                {this.getDelayProbability(item.deliverydata)}
                              </div>
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type={"light"}
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`docsFilteredBySender-${index}`}
                              >
                                <Button
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenFilesFromDoc(item)
                                  }
                                >
                                  {translate("View file")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenDocument(e, item.docnodeid)
                                  }
                                >
                                  {translate("View document")}
                                </Button>
                              </ReactTooltip>
                              {isLegacyCustomer(item.customer) ? (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredBySender-customer-legacy-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>
                                </ReactTooltip>
                              ) : (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredBySender-customer-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewConfig(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("Configure")}
                                  </Button>
                                </ReactTooltip>
                              )}
                              {this.isProjectExist(item.project) && (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"light"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredBySender-project-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                </ReactTooltip>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <div className="empty-result">
                      {translate("NoDocumentsMatchedSenderID")}
                    </div>
                  )}
                  {docsFilteredBySender.length > 0 && docsShowMoreSender && (
                    <button
                      style={{ margin: "5px" }}
                      type="button"
                      className="btn btn-secondary"
                      onClick={this.showMoreDocsSender}
                    >
                      {translate("Show more documents")}
                    </button>
                  )}
                </Col>
              </div>
            )}
            {docsFilteredBySenderName && (
              <div
                className="row search-result-panel"
                ref={(el) => {
                  this.docsBySenderNameResRef = el;
                }}
              >
                <Col
                  xs="2"
                  className="hidden-sm-screen-search"
                  style={{ margin: "0.5em 0" }}
                >
                  <StickyContainer style={{ height: "100%" }}>
                    <Sticky topOffset={-180} bottomOffset={-210}>
                      {({ style }) => (
                        <div
                          className="side-header"
                          style={{ ...style, top: "180px" }}
                        >
                          {translate("Documents by Sender Name")}
                        </div>
                      )}
                    </Sticky>
                    <div className="desc-header">
                      {translate(
                        "Documents are searched by the beginning of Sender name."
                      )}
                    </div>
                  </StickyContainer>
                </Col>
                <div
                  className="side-header ls-screen-hidden-search"
                  style={{ padding: "0.5em" }}
                >
                  {translate("Documents by Sender Name")}
                </div>
                <Col xs="10">
                  {loading_docs_sender_name ? (
                    <div className="smart-search-loading">
                      <div
                        className="spinner-border"
                        style={{ float: "left" }}
                      />
                      <div className="smart-search-loading-text">
                        {translate("Searching documents by Sender Name")}...
                      </div>
                    </div>
                  ) : docsFilteredBySenderName.length > 0 ? (
                    docsFilteredBySenderName.map((item, index) => (
                      <Row
                        className={"sub-search-panel row-status-" + item.status}
                        style={{ marginTop: "0.1em", borderLeftWidth: "3px" }}
                        key={index}
                      >
                        <Col style={{ padding: 0 }}>
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <strong>
                                {item.senderName
                                  ? highlight(
                                      item.senderName,
                                      smartSearchText && smartSearchText.trim()
                                    )
                                  : null}
                                {item.senderName && " "}
                                {item.sender
                                  ? highlight(
                                      "[" + item.sender + "]",
                                      smartSearchText && smartSearchText.trim()
                                    )
                                  : ""}
                              </strong>{" "}
                              Document Nr:{" "}
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="light"
                                data-delay-update={500}
                                data-for={`docsFilteredBySenderName-${index}`}
                              >
                                {item.mode === "test" && (
                                  <span>
                                    <i>[TEST]</i>{" "}
                                  </span>
                                )}{" "}
                                {item.documentNr || <i>[Not defined]</i>}
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>{" "}
                              {item.customer || item.project ? (
                                <span>
                                  {item.customer && (
                                    <span>
                                      Customer:{" "}
                                      <strong
                                        className="finger underline"
                                        data-tip
                                        data-type="info"
                                        data-delay-update={500}
                                        data-for={`docsFilteredBySenderName-customer${
                                          isLegacyCustomer(item.customer)
                                            ? "-legacy"
                                            : ""
                                        }-${index}`}
                                      >
                                        {item.customer}
                                        {isMobile && (
                                          <i className="fas fa-location-arrow button-list-icon" />
                                        )}
                                      </strong>{" "}
                                    </span>
                                  )}
                                  {item.project && (
                                    <span>
                                      Project:{" "}
                                      {this.isProjectExist(item.project) ? (
                                        <strong
                                          className="finger underline"
                                          data-tip
                                          data-type="info"
                                          data-delay-update={500}
                                          data-for={`docsFilteredBySenderName-project-${index}`}
                                        >
                                          {item.project}
                                          {isMobile && (
                                            <i className="fas fa-location-arrow button-list-icon" />
                                          )}
                                        </strong>
                                      ) : (
                                        <i>{item.project}</i>
                                      )}
                                    </span>
                                  )}
                                </span>
                              ) : null}
                            </div>
                            <div className="panel-body">
                              <div>
                                <span style={{ marginLeft: "1em" }}>
                                  Delivered:{" "}
                                  {item.timestamp
                                    ? moment
                                        .utc(item.timestamp, moment.ISO_8601)
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>{" "}
                                <span>
                                  Arrived:{" "}
                                  {item.fileArrivalTs
                                    ? moment
                                        .utc(
                                          item.fileArrivalTs,
                                          moment.ISO_8601
                                        )
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>
                                {this.getDelayProbability(item.deliverydata)}
                              </div>
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type={"light"}
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`docsFilteredBySenderName-${index}`}
                              >
                                <Button
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenFilesFromDoc(item)
                                  }
                                >
                                  {translate("View file")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenDocument(e, item.docnodeid)
                                  }
                                >
                                  {translate("View document")}
                                </Button>
                              </ReactTooltip>
                              {isLegacyCustomer(item.customer) ? (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredBySenderName-customer-legacy-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>
                                </ReactTooltip>
                              ) : (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredBySenderName-customer-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewConfig(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("Configure")}
                                  </Button>
                                </ReactTooltip>
                              )}
                              {this.isProjectExist(item.project) && (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"light"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredBySenderName-project-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                </ReactTooltip>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <div className="empty-result">
                      {translate("NoDocumentsMatchedSender")}
                    </div>
                  )}
                  {docsFilteredBySenderName.length > 0 &&
                    docsShowMoreSenderName && (
                      <button
                        style={{ margin: "5px" }}
                        type="button"
                        className="btn btn-secondary"
                        onClick={this.showMoreDocsSenderName}
                      >
                        {translate("Show more documents")}
                      </button>
                    )}
                </Col>
              </div>
            )}
            {docsFilteredByReceiver && (
              <div
                className="row search-result-panel"
                ref={(el) => {
                  this.docsByReceiverResRef = el;
                }}
              >
                <Col
                  xs="2"
                  className="hidden-sm-screen-search"
                  style={{ margin: "0.5em 0" }}
                >
                  <StickyContainer style={{ height: "100%" }}>
                    <Sticky topOffset={-180} bottomOffset={-210}>
                      {({ style }) => (
                        <div
                          className="side-header"
                          style={{ ...style, top: "180px" }}
                        >
                          {translate("Documents by Receiver ID")}
                        </div>
                      )}
                    </Sticky>
                    <div className="desc-header">
                      {translate(
                        "Documents are searched by the beginning of Receiver ID."
                      )}
                    </div>
                  </StickyContainer>
                </Col>
                <div
                  className="side-header ls-screen-hidden-search"
                  style={{ padding: "0.5em" }}
                >
                  {translate("Documents by Receiver ID")}
                </div>
                <Col xs="10">
                  {loading_docs_receiver ? (
                    <div className="smart-search-loading">
                      <div
                        className="spinner-border"
                        style={{ float: "left" }}
                      />
                      <div className="smart-search-loading-text">
                        {translate("Searching documents by Receiver ID")}...
                      </div>
                    </div>
                  ) : docsFilteredByReceiver.length > 0 ? (
                    docsFilteredByReceiver.map((item, index) => (
                      <Row
                        className={"sub-search-panel row-status-" + item.status}
                        style={{ marginTop: "0.1em", borderLeftWidth: "3px" }}
                        key={index}
                      >
                        <Col style={{ padding: 0 }}>
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <strong>
                                {item.receiverName
                                  ? highlight(
                                      item.receiverName,
                                      smartSearchText && smartSearchText.trim()
                                    )
                                  : null}
                                {item.receiverName && " "}
                                {item.receiver
                                  ? highlight(
                                      "[" + item.receiver + "]",
                                      smartSearchText && smartSearchText.trim()
                                    )
                                  : ""}
                              </strong>{" "}
                              Document Nr:{" "}
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="light"
                                data-delay-update={500}
                                data-for={`docsFilteredByReceiver-${index}`}
                              >
                                {item.mode === "test" && (
                                  <span>
                                    <i>[TEST]</i>{" "}
                                  </span>
                                )}{" "}
                                {item.documentNr || <i>[Not defined]</i>}
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>{" "}
                              {item.customer || item.project ? (
                                <span>
                                  {item.customer && (
                                    <span>
                                      Customer:{" "}
                                      <strong
                                        className="finger underline"
                                        data-tip
                                        data-type="info"
                                        data-delay-update={500}
                                        data-for={`docsFilteredByReceiver-customer${
                                          isLegacyCustomer(item.customer)
                                            ? "-legacy"
                                            : ""
                                        }-${index}`}
                                      >
                                        {item.customer}
                                        {isMobile && (
                                          <i className="fas fa-location-arrow button-list-icon" />
                                        )}
                                      </strong>{" "}
                                    </span>
                                  )}
                                  {item.project && (
                                    <span>
                                      Project:{" "}
                                      {this.isProjectExist(item.project) ? (
                                        <strong
                                          className="finger underline"
                                          data-tip
                                          data-type="info"
                                          data-delay-update={500}
                                          data-for={`docsFilteredByReceiver-project-${index}`}
                                        >
                                          {item.project}
                                          {isMobile && (
                                            <i className="fas fa-location-arrow button-list-icon" />
                                          )}
                                        </strong>
                                      ) : (
                                        <i>{item.project}</i>
                                      )}
                                    </span>
                                  )}
                                </span>
                              ) : null}
                            </div>
                            <div className="panel-body">
                              <div>
                                <span style={{ marginLeft: "1em" }}>
                                  Delivered:{" "}
                                  {item.timestamp
                                    ? moment
                                        .utc(item.timestamp, moment.ISO_8601)
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>{" "}
                                <span>
                                  Arrived:{" "}
                                  {item.fileArrivalTs
                                    ? moment
                                        .utc(
                                          item.fileArrivalTs,
                                          moment.ISO_8601
                                        )
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>
                                {this.getDelayProbability(item.deliverydata)}
                              </div>
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type={"light"}
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`docsFilteredByReceiver-${index}`}
                              >
                                <Button
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenFilesFromDoc(item)
                                  }
                                >
                                  {translate("View file")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenDocument(e, item.docnodeid)
                                  }
                                >
                                  {translate("View document")}
                                </Button>
                              </ReactTooltip>
                              {isLegacyCustomer(item.customer) ? (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredByReceiver-customer-legacy-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>
                                </ReactTooltip>
                              ) : (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredByReceiver-customer-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewConfig(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("Configure")}
                                  </Button>
                                </ReactTooltip>
                              )}
                              {this.isProjectExist(item.project) && (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"light"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredByReceiver-project-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                </ReactTooltip>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <div className="empty-result">
                      {translate("NoDocumentsMatchedReceiverID")}
                    </div>
                  )}
                  {docsFilteredByReceiver.length > 0 && docsShowMoreReceiver && (
                    <button
                      style={{ margin: "5px" }}
                      type="button"
                      className="btn btn-secondary"
                      onClick={this.showMoreDocsReceiver}
                    >
                      {translate("Show more documents")}
                    </button>
                  )}
                </Col>
              </div>
            )}
            {docsFilteredByReceiverName && (
              <div
                className="row search-result-panel"
                ref={(el) => {
                  this.docsByReceiverNameResRef = el;
                }}
              >
                <Col
                  xs="2"
                  className="hidden-sm-screen-search"
                  style={{ margin: "0.5em 0" }}
                >
                  <StickyContainer style={{ height: "100%" }}>
                    <Sticky topOffset={-180} bottomOffset={-210}>
                      {({ style }) => (
                        <div
                          className="side-header"
                          style={{ ...style, top: "180px" }}
                        >
                          {translate("Documents by Receiver Name")}
                        </div>
                      )}
                    </Sticky>
                    <div className="desc-header">
                      {translate(
                        "Documents are searched by the beginning of Receiver name."
                      )}
                    </div>
                  </StickyContainer>
                </Col>
                <div
                  className="side-header ls-screen-hidden-search"
                  style={{ padding: "0.5em" }}
                >
                  {translate("Documents by Receiver Name")}
                </div>
                <Col xs="10">
                  {loading_docs_receiver_name ? (
                    <div className="smart-search-loading">
                      <div
                        className="spinner-border"
                        style={{ float: "left" }}
                      />
                      <div className="smart-search-loading-text">
                        {translate("Searching documents by Receiver Name")}...
                      </div>
                    </div>
                  ) : docsFilteredByReceiverName.length > 0 ? (
                    docsFilteredByReceiverName.map((item, index) => (
                      <Row
                        className={"sub-search-panel row-status-" + item.status}
                        style={{ marginTop: "0.1em", borderLeftWidth: "3px" }}
                        key={index}
                      >
                        <Col style={{ padding: 0 }}>
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <strong>
                                {item.receiverName
                                  ? highlight(
                                      item.receiverName,
                                      smartSearchText && smartSearchText.trim()
                                    )
                                  : null}
                                {item.receiverName && " "}
                                {item.receiver
                                  ? highlight(
                                      "[" + item.receiver + "]",
                                      smartSearchText && smartSearchText.trim()
                                    )
                                  : ""}
                              </strong>{" "}
                              Document Nr:{" "}
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="light"
                                data-delay-update={500}
                                data-for={`docsFilteredByReceiverName-${index}`}
                              >
                                {item.mode === "test" && (
                                  <span>
                                    <i>[TEST]</i>{" "}
                                  </span>
                                )}{" "}
                                {item.documentNr || <i>[Not defined]</i>}
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>{" "}
                              {item.customer || item.project ? (
                                <span>
                                  {item.customer && (
                                    <span>
                                      Customer:{" "}
                                      <strong
                                        className="finger underline"
                                        data-tip
                                        data-type="info"
                                        data-delay-update={500}
                                        data-for={`docsFilteredByReceiverName-customer${
                                          isLegacyCustomer(item.customer)
                                            ? "-legacy"
                                            : ""
                                        }-${index}`}
                                      >
                                        {item.customer}
                                        {isMobile && (
                                          <i className="fas fa-location-arrow button-list-icon" />
                                        )}
                                      </strong>{" "}
                                    </span>
                                  )}
                                  {item.project && (
                                    <span>
                                      Project:{" "}
                                      {this.isProjectExist(item.project) ? (
                                        <strong
                                          className="finger underline"
                                          data-tip
                                          data-type="info"
                                          data-delay-update={500}
                                          data-for={`docsFilteredByReceiverName-project-${index}`}
                                        >
                                          {item.project}
                                          {isMobile && (
                                            <i className="fas fa-location-arrow button-list-icon" />
                                          )}
                                        </strong>
                                      ) : (
                                        <i>{item.project}</i>
                                      )}
                                    </span>
                                  )}
                                </span>
                              ) : null}
                            </div>
                            <div className="panel-body">
                              <div>
                                <span style={{ marginLeft: "1em" }}>
                                  Delivered:{" "}
                                  {item.timestamp
                                    ? moment
                                        .utc(item.timestamp, moment.ISO_8601)
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>{" "}
                                <span>
                                  Arrived:{" "}
                                  {item.fileArrivalTs
                                    ? moment
                                        .utc(
                                          item.fileArrivalTs,
                                          moment.ISO_8601
                                        )
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </span>
                                {this.getDelayProbability(item.deliverydata)}
                              </div>
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type={"light"}
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`docsFilteredByReceiverName-${index}`}
                              >
                                <Button
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenFilesFromDoc(item)
                                  }
                                >
                                  {translate("View file")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleOpenDocument(e, item.docnodeid)
                                  }
                                >
                                  {translate("View document")}
                                </Button>
                              </ReactTooltip>
                              {isLegacyCustomer(item.customer) ? (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredByReceiverName-customer-legacy-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByLegacyCustomer(e, {
                                        globalId:
                                          item.customer &&
                                          item.customer.substr &&
                                          item.customer.substr(3).trim(),
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>
                                </ReactTooltip>
                              ) : (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"info"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredByReceiverName-customer-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByCustomer(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewConfig(e, {
                                        globalId: item.customerid,
                                      })
                                    }
                                  >
                                    {translate("Configure")}
                                  </Button>
                                </ReactTooltip>
                              )}
                              {this.isProjectExist(item.project) && (
                                <ReactTooltip
                                  effect="solid"
                                  delayHide={500}
                                  delayShow={500}
                                  delayUpdate={500}
                                  place={"bottom"}
                                  border={true}
                                  type={"light"}
                                  className={`customeTheme2 ${
                                    isMobile ? "mobile-tip" : ""
                                  }`}
                                  id={`docsFilteredByReceiverName-project-${index}`}
                                >
                                  <Button
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewFilesByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View files")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDocsByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View documents")}
                                  </Button>{" "}
                                  <Button
                                    style={{ marginLeft: "1em" }}
                                    color="secondary"
                                    className="btn-posti-default"
                                    onClick={(e) =>
                                      this.viewDashboardByProjectId(e, {
                                        globalId: item.customerid,
                                        foundProjectId: item.project,
                                      })
                                    }
                                  >
                                    {translate("View dashboard")}
                                  </Button>{" "}
                                </ReactTooltip>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <div className="empty-result">
                      {translate("NoDocumentsMatchedReceiver")}
                    </div>
                  )}
                  {docsFilteredByReceiverName.length > 0 &&
                    docsShowMoreReceiverName && (
                      <button
                        style={{ margin: "5px" }}
                        type="button"
                        className="btn btn-secondary"
                        onClick={this.showMoreDocsReceiverName}
                      >
                        {translate("Show more documents")}
                      </button>
                    )}
                </Col>
              </div>
            )}
            {customersFilteredByName && (
              <div
                className="row search-result-panel"
                ref={(el) => {
                  this.customersResRef = el;
                }}
              >
                <Col
                  xs="2"
                  className="hidden-sm-screen-search"
                  style={{ margin: "0.5em 0" }}
                >
                  <StickyContainer style={{ height: "100%" }}>
                    <Sticky topOffset={-180} bottomOffset={-210}>
                      {({ style }) => (
                        <div
                          className="side-header"
                          style={{ ...style, top: "180px" }}
                        >
                          {translate("Customers")}
                        </div>
                      )}
                    </Sticky>
                  </StickyContainer>
                </Col>
                <div
                  className="side-header ls-screen-hidden-search"
                  style={{ padding: "0.5em" }}
                >
                  {translate("Customers")}
                </div>
                <Col xs="10">
                  {customersFilteredByName.length > 0 ? (
                    customersFilteredByName.map((item, index) => (
                      <Row
                        className="sub-search-panel"
                        style={{ marginTop: "0.1em" }}
                        key={index}
                      >
                        <Col style={{ padding: 0 }}>
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="light"
                                data-delay-update={500}
                                data-for={`customersFilteredByName-${index}`}
                              >
                                {highlight(
                                  item.name,
                                  smartSearchText && smartSearchText.trim()
                                )}
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>
                            </div>
                            <div className="panel-body">
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type={"light"}
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`customersFilteredByName-${index}`}
                              >
                                <Button
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.viewFilesByCustomer(e, item)
                                  }
                                >
                                  {translate("View files")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.viewDocsByCustomer(e, item)
                                  }
                                >
                                  {translate("View documents")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.viewDashboardByCustomer(e, item)
                                  }
                                >
                                  {translate("View dashboard")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) => this.viewConfig(e, item)}
                                >
                                  {translate("Configure")}
                                </Button>
                              </ReactTooltip>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <div className="empty-result">
                      {translate("NoDocumentsMatchedCustomer")}
                    </div>
                  )}
                </Col>
              </div>
            )}
            {customersFilteredByProjectName && (
              <div
                className="row search-result-panel"
                ref={(el) => {
                  this.customersByProjectResRef = el;
                }}
              >
                <Col
                  xs="2"
                  className="hidden-sm-screen-search"
                  style={{ margin: "0.5em 0" }}
                >
                  <StickyContainer style={{ height: "100%" }}>
                    <Sticky topOffset={-180} bottomOffset={-210}>
                      {({ style }) => (
                        <div
                          className="side-header"
                          style={{ ...style, top: "180px" }}
                        >
                          Projects
                        </div>
                      )}
                    </Sticky>
                  </StickyContainer>
                </Col>
                <div
                  className="side-header ls-screen-hidden-search"
                  style={{ padding: "0.5em" }}
                >
                  Projects
                </div>
                <Col xs="10">
                  {customersFilteredByProjectName.length > 0 ? (
                    customersFilteredByProjectName.map((item, index) => (
                      <Row
                        className="sub-search-panel"
                        style={{ marginTop: "0.1em" }}
                        key={index}
                      >
                        <Col style={{ padding: 0 }}>
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="light"
                                data-delay-update={500}
                                data-for={`customersFilteredByProjectName-${index}`}
                              >
                                {highlight(
                                  item.foundProjectName,
                                  smartSearchText
                                )}
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>{" "}
                              of customer{" "}
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="light"
                                data-delay-update={500}
                                data-for={`customersFilteredByProjectName-customer-${index}`}
                              >
                                {item.name}
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>
                            </div>
                            <div className="panel-body">
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type={"light"}
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`customersFilteredByProjectName-${index}`}
                              >
                                <Button
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.viewFilesByProjectId(e, item)
                                  }
                                >
                                  {translate("View files")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.viewDocsByProjectId(e, item)
                                  }
                                >
                                  {translate("View documents")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.viewDashboardByProjectId(e, item)
                                  }
                                >
                                  {translate("View dashboard")}
                                </Button>{" "}
                              </ReactTooltip>
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type={"light"}
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`customersFilteredByProjectName-customer-${index}`}
                              >
                                <Button
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.viewFilesByCustomer(e, item)
                                  }
                                >
                                  {translate("View files")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.viewDocsByCustomer(e, item)
                                  }
                                >
                                  {translate("View documents")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.viewDashboardByCustomer(e, item)
                                  }
                                >
                                  {translate("View dashboard")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) => this.viewConfig(e, item)}
                                >
                                  {translate("Configure")}
                                </Button>
                              </ReactTooltip>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <div className="empty-result">
                      It seems no projects match Project Name
                    </div>
                  )}
                </Col>
              </div>
            )}
            {customersFilteredByUserName && (
              <div
                className="row search-result-panel"
                ref={(el) => {
                  this.customersByUserResRef = el;
                }}
              >
                <Col
                  xs="2"
                  className="hidden-sm-screen-search"
                  style={{ margin: "0.5em 0" }}
                >
                  <StickyContainer style={{ height: "100%" }}>
                    <Sticky topOffset={-180} bottomOffset={-210}>
                      {({ style }) => (
                        <div
                          className="side-header"
                          style={{ ...style, top: "180px" }}
                        >
                          {translate("Users")}
                        </div>
                      )}
                    </Sticky>
                  </StickyContainer>
                </Col>
                <div
                  className="side-header ls-screen-hidden-search"
                  style={{ padding: "0.5em" }}
                >
                  {translate("Users")}
                </div>
                <Col xs="10">
                  {customersFilteredByUserName.length > 0 ? (
                    customersFilteredByUserName.map((item, index) => (
                      <Row
                        className="sub-search-panel"
                        style={{ marginTop: "0.1em" }}
                        key={index}
                      >
                        <Col style={{ padding: 0 }}>
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="light"
                                data-delay-update={500}
                                data-for={`customersFilteredByUserName-${index}`}
                              >
                                {highlight(
                                  item.UserId,
                                  smartSearchText && smartSearchText.trim()
                                )}
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>{" "}
                              of customer{" "}
                              <strong>
                                {item.CompanyName || <i>[Unknown]</i>}
                              </strong>
                            </div>
                            <div className="panel-body">
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type={"light"}
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`customersFilteredByUserName-${index}`}
                              >
                                <Button
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.handleSwitchUser(e, item)
                                  }
                                >
                                  {translate("Switch to")}
                                </Button>
                              </ReactTooltip>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <div className="empty-result">
                      It seems no users match User Name
                    </div>
                  )}
                </Col>
              </div>
            )}
            {customersFilteredBySender && (
              <div
                className="row search-result-panel"
                ref={(el) => {
                  this.customersBySenderResRef = el;
                }}
              >
                <Col
                  xs="2"
                  className="hidden-sm-screen-search"
                  style={{ margin: "0.5em 0" }}
                >
                  <StickyContainer style={{ height: "100%" }}>
                    <Sticky topOffset={-180} bottomOffset={-210}>
                      {({ style }) => (
                        <div
                          className="side-header"
                          style={{ ...style, top: "180px" }}
                        >
                          Senders
                        </div>
                      )}
                    </Sticky>
                  </StickyContainer>
                </Col>
                <div
                  className="side-header ls-screen-hidden-search"
                  style={{ padding: "0.5em" }}
                >
                  Senders
                </div>
                <Col xs="10">
                  {customersFilteredBySender.length > 0 ? (
                    customersFilteredBySender.map((item, index) => (
                      <Row
                        className="sub-search-panel"
                        style={{ marginTop: "0.1em" }}
                        key={index}
                      >
                        <Col style={{ padding: 0 }}>
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="light"
                                data-delay-update={500}
                                data-for={`customersFilteredBySender-${index}`}
                              >
                                {highlight(
                                  item.foundSenderName,
                                  smartSearchText
                                )}
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>{" "}
                              of customer{" "}
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="light"
                                data-delay-update={500}
                                data-for={`customersFilteredBySender-customer-${index}`}
                              >
                                {item.name}
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>
                            </div>
                            <div className="panel-body">
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type={"light"}
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`customersFilteredBySender-${index}`}
                              >
                                <Button
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.viewDocsBySenderId(e, item)
                                  }
                                >
                                  {translate("View documents")}
                                </Button>
                              </ReactTooltip>
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type={"light"}
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`customersFilteredBySender-customer-${index}`}
                              >
                                <Button
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.viewFilesByCustomer(e, item)
                                  }
                                >
                                  {translate("View files")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.viewDocsByCustomer(e, item)
                                  }
                                >
                                  {translate("View documents")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.viewDashboardByCustomer(e, item)
                                  }
                                >
                                  {translate("View dashboard")}
                                </Button>{" "}
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) => this.viewConfig(e, item)}
                                >
                                  {translate("Configure")}
                                </Button>
                              </ReactTooltip>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <div className="empty-result">
                      It seems no senders match Sender Name
                    </div>
                  )}
                </Col>
              </div>
            )}
            {filteredChannels && (
              <div
                className="row search-result-panel"
                ref={(el) => {
                  this.channelsResRef = el;
                }}
              >
                <Col
                  xs="2"
                  className="hidden-sm-screen-search"
                  style={{ margin: "0.5em 0" }}
                >
                  <StickyContainer style={{ height: "100%" }}>
                    <Sticky topOffset={-180} bottomOffset={-210}>
                      {({ style }) => (
                        <div
                          className="side-header"
                          style={{ ...style, top: "180px" }}
                        >
                          {translate("Channels")}
                        </div>
                      )}
                    </Sticky>
                  </StickyContainer>
                </Col>
                <div
                  className="side-header ls-screen-hidden-search"
                  style={{ padding: "0.5em" }}
                >
                  {translate("Channels")}
                </div>
                <Col xs="10">
                  {filteredChannels.length > 0 ? (
                    filteredChannels.map((item, index) => (
                      <Row
                        className="sub-search-panel"
                        style={{ marginTop: "0.1em" }}
                        key={index}
                      >
                        <Col style={{ padding: 0 }}>
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="light"
                                data-delay-update={500}
                                data-for={`filteredChannels-${index}`}
                              >
                                {highlight(
                                  item,
                                  smartSearchText && smartSearchText.trim()
                                )}
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>
                            </div>
                            <ReactTooltip
                              effect="solid"
                              delayHide={500}
                              delayShow={500}
                              delayUpdate={500}
                              place={"bottom"}
                              border={true}
                              type={"light"}
                              className={`customeTheme2 ${
                                isMobile ? "mobile-tip" : ""
                              }`}
                              id={`filteredChannels-${index}`}
                            >
                              <Button
                                color="secondary"
                                className="btn-posti-default"
                                onClick={(e) =>
                                  this.viewFilesByChannel(e, item)
                                }
                              >
                                {translate("View files")}
                              </Button>{" "}
                              <Button
                                style={{ marginLeft: "1em" }}
                                color="secondary"
                                className="btn-posti-default"
                                onClick={(e) => this.viewDocsByChannel(e, item)}
                              >
                                {translate("View documents")}
                              </Button>
                            </ReactTooltip>
                          </div>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <div className="empty-result">
                      It seems no channels match Channel Name
                    </div>
                  )}
                </Col>
              </div>
            )}
            {batchesFiltered && (
              <div
                className="row search-result-panel"
                ref={(el) => {
                  this.batchesResRef = el;
                }}
              >
                <Col
                  xs="2"
                  className="hidden-sm-screen-search"
                  style={{ margin: "0.5em 0" }}
                >
                  <StickyContainer style={{ height: "100%" }}>
                    <Sticky topOffset={-180} bottomOffset={-210}>
                      {({ style }) => (
                        <div
                          className="side-header"
                          style={{ ...style, top: "180px" }}
                        >
                          Batches
                        </div>
                      )}
                    </Sticky>
                    <div className="desc-header">
                      Batches are searched using exact Batch ID.
                    </div>
                  </StickyContainer>
                </Col>
                <div
                  className="side-header ls-screen-hidden-search"
                  style={{ padding: "0.5em" }}
                >
                  Batches
                </div>
                <Col xs="10">
                  {loading_batches ? (
                    <div className="smart-search-loading">
                      <div
                        className="spinner-border"
                        style={{ float: "left" }}
                      />
                      <div className="smart-search-loading-text">
                        Searching batches by Batch ID...
                      </div>
                    </div>
                  ) : batchesFiltered.length > 0 ? (
                    batchesFiltered.map((item, index) => (
                      <Row
                        className="sub-search-panel"
                        style={{
                          marginTop: "0.1em",
                          borderLeft: "3px #d7dbdd solid",
                        }}
                        key={index}
                      >
                        <Col style={{ padding: 0 }}>
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <strong>
                                {highlight(
                                  item.BatchId,
                                  smartSearchText && smartSearchText.trim()
                                )}
                              </strong>{" "}
                              <strong
                                className="finger underline"
                                data-tip
                                data-type="light"
                                data-delay-update={500}
                                data-for={`batchesFiltered-${index}`}
                              >
                                {item.DocumentCount}{" "}
                                <em>
                                  {item.DocumentCount === 1
                                    ? "document"
                                    : "documents"}
                                </em>
                                {isMobile && (
                                  <i className="fas fa-location-arrow button-list-icon" />
                                )}
                              </strong>
                              <div>
                                <span>
                                  Sent to channels{" "}
                                  <strong>
                                    {item.Channels && item.Channels.length ? (
                                      item.Channels.join(", ")
                                    ) : (
                                      <i>[Unknown]</i>
                                    )}
                                  </strong>
                                </span>
                              </div>
                              <ReactTooltip
                                effect="solid"
                                delayHide={500}
                                delayShow={500}
                                delayUpdate={500}
                                place={"bottom"}
                                border={true}
                                type={"light"}
                                className={`customeTheme2 ${
                                  isMobile ? "mobile-tip" : ""
                                }`}
                                id={`batchesFiltered-${index}`}
                              >
                                <Button
                                  style={{ marginLeft: "1em" }}
                                  color="secondary"
                                  className="btn-posti-default"
                                  onClick={(e) =>
                                    this.viewDocsByBatchID(e, item.BatchId)
                                  }
                                >
                                  {translate("View documents")}
                                </Button>
                              </ReactTooltip>
                            </div>
                            <div className="panel-body" />
                          </div>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <div className="empty-result">
                      It seems no batches matches Batch ID
                    </div>
                  )}
                </Col>
              </div>
            )}
            {!loading_docs_ebid && notFoundEBID.length > 0 && (
              <div
                className="row search-result-panel"
                style={{ padding: "1em", display: "block" }}
              >
                <div className="side-header">Unfound EBIDs:</div>
                <div style={{ color: "red" }}>{notFoundEBID.join(", ")}</div>
              </div>
            )}
          </Container>
        </div>
      </div>
    );
  }
}

function isLegacyCustomer(title) {
  return !!title && title.startsWith("ID:");
}

function highlight(originText, text, matchCommaList) {
  if (!originText) return originText;
  if (matchCommaList) {
    let _docNrs = text.toString().trim().split(",");
    for (let i = 0; i < _docNrs.length; i++) {
      const element = _docNrs[i];
      if (element.trim().length) {
        var index = originText
          .toLowerCase()
          .indexOf(element.trim().toLowerCase());
        if (index >= 0) {
          return (
            <span>
              {originText.substring(0, index)}
              <span className="highlight">
                {originText.substring(index, index + element.trim().length)}
              </span>
              {originText.substring(index + element.trim().length)}
            </span>
          );
        }
      }
    }
  } else {
    let index = originText.toLowerCase().indexOf(text.toLowerCase());
    if (index >= 0) {
      return (
        <span>
          {originText.substring(0, index)}
          <span className="highlight">
            {originText.substring(index, index + text.length)}
          </span>
          {originText.substring(index + text.length)}
        </span>
      );
    }
  }

  return originText;
}

let requestAnimFrame = (function () {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    }
  );
})();

function scrollToY(scrollTargetY, speed, easing) {
  // scrollTargetY: the target scrollY property of the window
  // speed: time in pixels per second
  // easing: easing equation to use
  let currentTime = 0;
  const scrollY = window.scrollY;

  scrollTargetY = scrollTargetY || 0;
  speed = speed || 2000;
  easing = easing || "easeOutSine";

  // min time .1, max time .8 seconds
  const time = Math.max(
    0.1,
    Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8)
  );

  // easing equations from https://github.com/danro/easing-js/blob/master/easing.js
  const easingEquations = {
    easeOutSine: function (pos) {
      return Math.sin(pos * (Math.PI / 2));
    },
    easeInOutSine: function (pos) {
      return -0.5 * (Math.cos(Math.PI * pos) - 1);
    },
    easeInOutQuint: function (pos) {
      if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 5);
      }
      return 0.5 * (Math.pow(pos - 2, 5) + 2);
    },
  };

  // add animation loop
  function tick() {
    currentTime += 1 / 60;
    var p = currentTime / time;
    var t = easingEquations[easing](p);
    if (p < 1) {
      requestAnimFrame(tick);
      window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
    } else {
      window.scrollTo(0, scrollTargetY);
    }
  }
  // call it once to get started
  tick();
}

function mapStateToProps(state) {
  const {
    smartSearch,
    smartSearchParams,
    authentication,
    locale,
    config,
    settings,
  } = state;
  const {
    user: { pageItemCount },
  } = authentication;
  return {
    allCustomers: config.allCustomers,
    allChannels: config.channels,
    selCustomerConfigReportsSize: config.selCustomerConfigReportsSize,
    allProjects: config.allProjects,

    availableUsers: settings.availableUsers,

    customersFilteredByName: smartSearch.customersFilteredByName,
    customersFilteredByUserName: smartSearch.customersFilteredByUserName,
    customersFilteredByProjectName: smartSearch.customersFilteredByProjectName,
    customersFilteredBySender: smartSearch.customersFilteredBySender,
    customersFilteredByDate: smartSearch.customersFilteredByDate,
    docsFilteredByEBID: smartSearch.docsFilteredByEBID,

    docsFilteredByDocNum: smartSearch.docsFilteredByDocNum,
    docsFilteredBySender: smartSearch.docsFilteredBySender,
    docsFilteredBySenderName: smartSearch.docsFilteredBySenderName,
    docsFilteredByReceiver: smartSearch.docsFilteredByReceiver,
    docsFilteredByReceiverName: smartSearch.docsFilteredByReceiverName,

    filesFilteredByFileName: smartSearch.filesFilteredByFileName,
    filesFilteredByCustomerId: smartSearch.filesFilteredByCustomerId,

    filteredChannels: smartSearch.filteredChannels,

    search_requested: smartSearch.search_requested,

    loading_files: smartSearch.loading_files,
    loading_files_customer: smartSearch.loading_files_customer,
    loading_docs: smartSearch.loading_docs,
    loading_docs_ebid: smartSearch.loading_docs_ebid,
    loading_docs_sender: smartSearch.loading_docs_sender,
    loading_docs_sender_name: smartSearch.loading_docs_sender_name,
    loading_docs_receiver: smartSearch.loading_docs_receiver,
    loading_docs_receiver_name: smartSearch.loading_docs_receiver_name,

    filesShowMore: smartSearch.filesShowMore,
    filesShowMoreByCustomerId: smartSearch.filesShowMoreByCustomerId,
    docsShowMore: smartSearch.docsShowMore,
    docsShowMoreSender: smartSearch.docsShowMoreSender,
    docsShowMoreSenderName: smartSearch.docsShowMoreSenderName,
    docsShowMoreReceiver: smartSearch.docsShowMoreReceiver,
    docsShowMoreReceiverName: smartSearch.docsShowMoreReceiverName,

    smartSearchText: smartSearch.smartSearchText,

    byEBID: smartSearch.byEBID,

    loading_batches: smartSearch.loading_batches,
    batchesFiltered: smartSearch.batchesFiltered,
    batchesShowMore: smartSearch.batchesShowMore,

    smartSearchParams,
    pageItemCount,
    translate: getTranslate(locale),
  };
}

const connectedSmartSearch = connect(mapStateToProps)(withRouter(SmartSearch));
export { connectedSmartSearch as SmartSearch };
